/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useState, useEffect, useCallback, useRef, useMemo} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {roleQUERIES, isNotEmpty, toAbsoluteUrl, KTSVG} from '../../../../../_metronic/helpers'
import {initialUser, User, CustomDictionaryModel, UserEditModalLookups} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {
  createUser,
  getUserroles,
  updateUser,
  getCustomerLocationsMulti,
  getSubAccountsShortListMulti,
  GetPinCode,
  CheckPinAvailability,
  checkUserEmail,
} from '../core/_requests'
import {
  getAllPreCallQuestionByCustomer,
  getCustomers,
  getServiceTypeByCustomerCode,
} from '../../../Common/components/core/_requests'
import {
  useLanguages,
  useTimeZones,
  useGenders,
  useCustomers,
} from '../../../../hooks/useGlobalData'
import ImageComponent from '../../../configuration-management/components/ImageComponent'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {useMutation, useQuery} from 'react-query'

import axios from 'axios'
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import toaster from '../../../../../Utils/toaster'
import debounce from 'lodash/debounce'
import './Style.css'
import Select from 'react-select'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  Suggestion,
} from 'react-places-autocomplete'
import {useAuth} from '../../../../modules/auth'
import {getUserByToken} from '../../../../modules/auth/core/_requests'
import { Smartphone, ChevronDown, ChevronUp, X } from 'lucide-react'
import {DeactivationReasonSelect} from '../components/DeactivationReasonSelect'

interface AccountItem {
  value: any
  label: string
  id: any
  isParent: boolean
  customerId: any
}

interface CustomerAccountGroup {
  customerId: any
  customerName: string
  parentAccount: AccountItem
  subAccounts: AccountItem[]
  allAccounts: AccountItem[]
  isLoading?: boolean
}

const withLockedParentAccounts = (
  subs: any[],
  lockedParents: {value: any; label: string; id?: any}[]
): any[] => {
  if (!lockedParents.length) return subs
  const merged = [...subs]
  for (const p of lockedParents) {
    if (!merged.some((s: any) => String(s.value) === String(p.value))) {
      merged.push({value: p.value, label: p.label, id: p.id ?? p.value})
    }
  }
  return merged
}

interface IndeterminateCheckboxProps {
  id?: string
  checked: boolean
  indeterminate?: boolean
  disabled?: boolean
  className?: string
  onChange: () => void
}

const IndeterminateCheckbox: FC<IndeterminateCheckboxProps> = ({
  id,
  checked,
  indeterminate = false,
  disabled = false,
  className = '',
  onChange,
}) => {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  return (
    <input
      type='checkbox'
      id={id}
      ref={ref}
      className={clsx('form-check-input', className)}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  )
}

interface RenderFuncProps {
  getInputProps: () => React.InputHTMLAttributes<HTMLInputElement>
  getSuggestionItemProps: (suggestion: Suggestion) => React.HTMLAttributes<HTMLDivElement>
  suggestions: any
  loading?: boolean // Optional loading indicator
  error: any
}

const styles = `

.phoneNumber input{
    border: none; 
    outline: none; 

  }
`
type Props = {
  isUserLoading: boolean
  user: User
  userType: string
  customerCode: number
  editLookups?: UserEditModalLookups
}

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const editUserSchema = Yup.object().shape({
  firstName: Yup.string().min(2, 'Minimum 2 characters').required('Required'),
  lastName: Yup.string().min(2, 'Minimum 2 characters').required('Required'),
  email: Yup.string()
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email')
    .email('Please enter valid email address')
    .required('Required'),
  password: Yup.string()
  .transform((value) => (value === null ? '' : value)) // Convert null → ''
  .when('setPassword', {
    is: true,
    then: (schema) =>
      schema
        .required('Password is required')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?=\S+$).{8,}$/,
          'Password must be at least 8 characters, include one uppercase, one lowercase, one special character, and no spaces'
        ),
    otherwise: (schema) => schema.notRequired(),
  }),


  phoneNumber: Yup.string(),
  pinCode: Yup.string()
    .matches(/^\d{4,10}$/, 'PIN must be between 4 and 10 digits')
    .required('Required'),
  fK_Customer: Yup.string().required('Required'),
  customerIds: Yup.array().when('userType', {
    is: 'CONSUMER',
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.notRequired(),
  }),
  fK_Location: Yup.string().required('Required'),
  fK_PreCallPolicy: Yup.string(),
  isNewPasswordGenerate: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  street1: Yup.string(),
  street2: Yup.string(),
  city: Yup.string().required('Required'),
  state: Yup.string().required('Required'),
  country: Yup.string().required('Required'),
  postalCode: Yup.string().required('Required'),
  latitude: Yup.number(),
  longitude: Yup.number(),
  isActive: Yup.boolean(),
  role: Yup.string().required('Required'),
  fK_DefaultNativeLanguage: Yup.string().required('Required'),
  userType: Yup.string(),
  serviceTypes: Yup.array().when('userType', {
    is: 'CONSUMER',
    then: Yup.array().required('Required').min(1, 'Required'),
    otherwise: Yup.array().notRequired(),
  }),
  secondaryOpiServiceTypes: Yup.array().notRequired(),
  fK_ServiceType: Yup.string().when('userType', {
    is: 'CONSUMER',
    then: Yup.string().required('Required'),
    otherwise: Yup.string().notRequired(),
  }),
  fK_DefaultTimeZone: Yup.string().required('Required'),
  fK_Gender: Yup.string().when('userType', {
    is: 'INTERPRETER',
    then: Yup.string().required('Required'),
    otherwise: Yup.string().notRequired(),
  }),
  linguistType: Yup.number().when('userType', {
    is: 'INTERPRETER',
    then: Yup.number().required('Required'),
    otherwise: Yup.number().notRequired(),
  }),
  payableType: Yup.number().when('userType', {
    is: 'INTERPRETER',
    then: Yup.number().required('Required'),
    otherwise: Yup.number().notRequired(),
  }),
  subCustomers: Yup.array().when('userType', {
    is: 'CONSUMER',
    then: Yup.array()
      .min(1, 'At least one account is required')
      .required('Required'),
    otherwise: Yup.array().notRequired(),
  }),
})

const UserEditModalForm: FC<Props> = ({
  user,
  isUserLoading,
  userType,
  customerCode,
  editLookups,
}) => {
  const hiddenFileInput = useRef<any>(null)
  const {currentUser, setCurrentUser} = useAuth()
  // If the logged in user's id/code matches the user being edited,
  // disable role editing to prevent changing your own role.
  const isEditingSelf =
    currentUser?.result?.code !== undefined &&
    String(currentUser?.result?.code) === String(user?.code)
  /** Requester editing own profile: company, associated customers, and applicable accounts are read-only. */
  const lockConsumerCustomerFields = isEditingSelf && userType === 'CONSUMER'
  const isAdmin = currentUser?.result?.role === 'Admin'
  const [selectedFile, setSelectedFile] = useState()
  const [preview, setPreview] = useState('')
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [customerLocation, setCustomerLocation] = useState<CustomDictionaryModel[]>([])
  // Sub customers state
  const [subCustomers, setSubCustomers] = useState<{ value: any; label: string; id: any }[]>([])
  const [selectedSubCustomers, setSelectedSubCustomers] = useState<{ value: any; label: string; id: any }[]>([])
  const [isGenPinCode, setIsGenPinCode] = useState(true)
  const [userForEdit, setUserForEdit] = useState<User>({
    ...user,
    lockoutEnabled: user.lockoutEnabled ?? initialUser.lockoutEnabled,
    recieveAllEmails: user.recieveAllEmails ?? initialUser.recieveAllEmails,
    recieveUserEmails: user.recieveUserEmails ?? initialUser.recieveUserEmails,
    profileImage: user.profileImage ?? initialUser.profileImage,
    osI_OnsiteWhisper: user.osI_OnsiteWhisper ?? initialUser.osI_OnsiteWhisper,
    osI_Onsite: user.osI_Onsite ?? initialUser.osI_Onsite,
    avatar: user.avatar || initialUser.avatar,
    role: user.role || user.userType == 'INTERPRETER' ? user.role : initialUser.role,
    position: user.position || initialUser.position,
    firstName: user.firstName || initialUser.firstName,
    email: user.email || initialUser.email,
    lastName: user.lastName || initialUser.lastName,
    phoneNumber: user.phoneNumber || initialUser.phoneNumber,
    fK_Customer: user.fK_Customer || initialUser.fK_Customer,
    fK_Gender: user.fK_Gender || initialUser.fK_Gender,
    fK_PreCallPolicy: user.fK_PreCallPolicy || initialUser.fK_PreCallPolicy,
    fK_Location: user.fK_Location || initialUser.fK_Location,
    isNewPasswordGenerate:
      user.code == undefined || user.code == '' || user.code == '0' ? true : false,
    pinCode: user.pinCodeString,
    pinCodeString: user.pinCodeString,
    address: user.address || initialUser.address,
    city: user.city || initialUser.city,
    state: user.state || initialUser.state,
    country: user.country || initialUser.country,
    postalCode: user.postalCode || initialUser.postalCode,
    street1: user.street1 || initialUser.street1,
    street2: user.street2 || initialUser.street2,
    latitude: user.latitude || initialUser.latitude,
    longitude: user.longitude || initialUser.longitude,
    fK_DefaultNativeLanguage: user.fK_DefaultNativeLanguage || initialUser.fK_DefaultNativeLanguage,
    fK_ServiceType: user.fK_ServiceType || initialUser.fK_ServiceType,
    serviceTypes: user.serviceTypes || initialUser.serviceTypes,
    secondaryOpiServiceTypes: user.secondaryOpiServiceTypes || initialUser.secondaryOpiServiceTypes,
    fK_DefaultTimeZone: user.fK_DefaultTimeZone || initialUser.fK_DefaultTimeZone,
    opI_ShdTelephonic: userType === 'SYSTEM' || user.opI_ShdTelephonic,
    opI_OndemandTelephonic: userType === 'SYSTEM' || user.opI_OndemandTelephonic,
    vrI_ShdVideoInteroreting: userType === 'SYSTEM' || user.vrI_ShdVideoInteroreting,
    vrI_OndemandVideoInteroreting: userType === 'SYSTEM' || user.vrI_OndemandVideoInteroreting,
    osI_OnsiteConsecutive: userType === 'SYSTEM' || user.osI_OnsiteConsecutive,
    osI_OnsiteSimultaneous: userType === 'SYSTEM' || user.osI_OnsiteSimultaneous,
    other_3rdPartyPlatform: userType === 'SYSTEM' || user.other_3rdPartyPlatform,
    translations: user.translations ?? false,
    userType: userType || initialUser.userType,
    accessBilling:
      user.accessBilling !== undefined && user.accessBilling !== null
        ? user.accessBilling
        : (user.userFeatures?.some((uf) => uf.feature.code.toLowerCase() === 'billing') ?? false),
    requesterSubcustomrs: user.requesterSubcustomrs
    ? user.requesterSubcustomrs.map((sub: any) => ({
        code: sub.code,
        name: sub.name,
      }))
    : [],
    password: null,
    linguistType: user.linguistType ?? initialUser.linguistType,
    payableType: user.payableType ?? initialUser.payableType,
    isAllowedMobileLogin:
      user.isAllowedMobileLogin ??
      (user as User & {IsAllowedMobileLogin?: boolean}).IsAllowedMobileLogin ??
      initialUser.isAllowedMobileLogin,
  });

  const [newPinCode, setNewPinCode] = useState('')

  // Multi-customer state for CONSUMER
  const [selectedCustomers, setSelectedCustomers] = useState<{value: any; label: string}[]>([])
  const [customerSearch, setCustomerSearch] = useState('')
  const [isCustomerDropdownOpen, setIsCustomerDropdownOpen] = useState(false)
  const customerDropdownRef = useRef<HTMLDivElement>(null)
  const [customerGroups, setCustomerGroups] = useState<Record<string, CustomerAccountGroup>>({})
  const [expandedCustomers, setExpandedCustomers] = useState<Record<string, boolean>>({})
  const [consumerServiceOptions, setConsumerServiceOptions] = useState<{value: any; label: string}[]>([])
  const serverLookupsAppliedForUserRef = useRef<string | null>(null)
  /** Run consumer associated/applicable init once per modal open (avoids reset + API storm on `user` refetch). */
  const consumerSessionInitRef = useRef<string | null>(null)
  const consumerAccountsLoadedForSessionRef = useRef<string | null>(null)

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        customerDropdownRef.current &&
        !customerDropdownRef.current.contains(event.target as Node)
      ) {
        setIsCustomerDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  const buildCustomerGroup = (
    customerId: any,
    customerName: string,
    subAccounts: AccountItem[]
  ): {group: CustomerAccountGroup; allAccounts: AccountItem[]} => {
    const parentAccount: AccountItem = {
      value: customerId,
      label: customerName,
      id: customerId,
      isParent: true,
      customerId,
    }
    const allAccounts = [parentAccount, ...subAccounts]
    return {
      group: {
        customerId,
        customerName,
        parentAccount,
        subAccounts,
        allAccounts,
        isLoading: false,
      },
      allAccounts,
    }
  }

  const fetchAndSetCustomerAccounts = async (customerId: any, customerName: string) => {
    const result = await fetchAndSetCustomerAccountsMulti([{value: customerId, label: customerName}])
    return result[String(customerId)] || buildCustomerGroup(customerId, customerName, []).allAccounts
  }

  const fetchAndSetCustomerAccountsMulti = async (
    customers: {value: any; label: string}[]
  ): Promise<Record<string, AccountItem[]>> => {
    const accountsByCustomerId: Record<string, AccountItem[]> = {}
    if (customers.length === 0) return accountsByCustomerId

    const parentIds = customers
      .map((c) => Number(c.value))
      .filter((v) => !isNaN(v) && v > 0)

    const subAccountsByParent = new Map<string, AccountItem[]>()

    if (parentIds.length > 0) {
      try {
        const res = await getSubAccountsShortListMulti(parentIds)
        for (const d of res?.data || []) {
          const parentId = String(d.parentCustomerId ?? d.ParentCustomerId ?? '')
          if (!parentId) continue
          const item: AccountItem = {
            value: d.code ?? d.Code,
            label: d.name ?? d.Name,
            id: d.code ?? d.Code,
            isParent: false,
            customerId: parentId,
          }
          const list = subAccountsByParent.get(parentId) || []
          list.push(item)
          subAccountsByParent.set(parentId, list)
        }
      } catch (err) {
        console.error('Error fetching sub-accounts multi:', err)
      }
    }

    setCustomerGroups((prev) => {
      const next = {...prev}
      for (const cust of customers) {
        const subAccounts = subAccountsByParent.get(String(cust.value)) || []
        const {group, allAccounts} = buildCustomerGroup(cust.value, cust.label, subAccounts)
        next[String(cust.value)] = group
        accountsByCustomerId[String(cust.value)] = allAccounts
      }
      return next
    })

    return accountsByCustomerId
  }

  const populateCustomerGroupsFromSubAccounts = (
    customers: {value: any; label: string}[],
    subAccountsList: any[]
  ) => {
    const subAccountsByParent = new Map<string, AccountItem[]>()
    for (const d of subAccountsList || []) {
      const parentId = String(d.parentCustomerId ?? d.ParentCustomerId ?? '')
      if (!parentId) continue
      const item: AccountItem = {
        value: d.code ?? d.Code,
        label: d.name ?? d.Name,
        id: d.code ?? d.Code,
        isParent: false,
        customerId: parentId,
      }
      const list = subAccountsByParent.get(parentId) || []
      list.push(item)
      subAccountsByParent.set(parentId, list)
    }

    setCustomerGroups((prev) => {
      const next = {...prev}
      for (const cust of customers) {
        const subAccounts = subAccountsByParent.get(String(cust.value)) || []
        const {group} = buildCustomerGroup(cust.value, cust.label, subAccounts)
        next[String(cust.value)] = group
      }
      return next
    })
  }

  useEffect(() => {
    if (!user?.code || !editLookups) return
    const userKey = String(user.code)
    if (serverLookupsAppliedForUserRef.current === userKey) return
    serverLookupsAppliedForUserRef.current = userKey

    if (editLookups.officeLocations?.length) {
      setCustomerLocation(editLookups.officeLocations)
    }
    if (userType === 'CONSUMER') {
      if (editLookups.customerServiceTypes?.length) {
        setConsumerServiceOptions(
          editLookups.customerServiceTypes.map((d) => ({
            value: d.key ?? '',
            label: d.value ?? d.key ?? '',
          }))
        )
      }
      if (editLookups.preCallPolicies?.length) {
        setPreCallPolicies(
          editLookups.preCallPolicies.map((d) => ({
            value: d.value ?? d.key,
            label: d.label ?? d.value ?? '',
          }))
        )
      }
    }
  }, [user?.code, editLookups, userType])

  useEffect(() => {
    if (userType === 'CONSUMER') {
      const sessionKey =
        itemIdForUpdate != null ? `edit-${itemIdForUpdate}` : `create-${user?.code ?? 'new'}`
      if (consumerSessionInitRef.current === sessionKey) {
        return
      }
      consumerSessionInitRef.current = sessionKey
      consumerAccountsLoadedForSessionRef.current = null

      const primaryId =
        user.fK_Customer != null && user.fK_Customer !== ''
          ? Number(user.fK_Customer)
          : null
      let initialAssociated: {value: any; label: string}[] = []
      if (user.customerAccess && user.customerAccess.length > 0) {
        initialAssociated = user.customerAccess
          .filter((c) => primaryId == null || Number(c.code) !== primaryId)
          .map((c) => ({
            value: c.code,
            label: c.name,
          }))
      }
      setSelectedCustomers(initialAssociated)
      formik.setFieldValue(
        'customerIds',
        initialAssociated.map((c) => Number(c.value))
      )

      const parentsForAccounts: {value: any; label: string}[] = []
      if (primaryId != null && !isNaN(primaryId) && primaryId > 0) {
        parentsForAccounts.push({
          value: primaryId,
          label: user.customerName || `Customer #${primaryId}`,
        })
      }
      initialAssociated.forEach((c) => {
        if (!parentsForAccounts.some((p) => String(p.value) === String(c.value))) {
          parentsForAccounts.push(c)
        }
      })

      const lockedFromCustomers = parentsForAccounts.map((c) => ({
        value: c.value,
        label: c.label,
        id: c.value,
      }))
      if (user.requesterSubcustomrs && user.requesterSubcustomrs.length > 0) {
        const subOpts = user.requesterSubcustomrs.map((sub: any) => ({
          value: sub.code,
          label: sub.name,
          id: sub.code,
        }))
        setSelectedSubCustomers(subOpts)
        formik.setFieldValue(
          'subCustomers',
          withLockedParentAccounts(subOpts, lockedFromCustomers)
        )
      } else if (parentsForAccounts.length > 0) {
        const defaultSub = [
          {
            value: parentsForAccounts[0].value,
            label: parentsForAccounts[0].label,
            id: parentsForAccounts[0].value,
          },
        ]
        setSelectedSubCustomers(defaultSub)
        formik.setFieldValue(
          'subCustomers',
          withLockedParentAccounts(defaultSub, lockedFromCustomers)
        )
      }

      const initialExpanded: Record<string, boolean> = {}
      parentsForAccounts.forEach((c) => {
        initialExpanded[String(c.value)] = true
      })
      setExpandedCustomers(initialExpanded)
    } else {
      if (userType !== 'INTERPRETER' && user.requesterSubcustomrs) {
        const subCustomerOptions = user.requesterSubcustomrs.map((sub: any) => ({
          value: sub.code,
          label: sub.name,
          id: sub.code,
        }))
        setSelectedSubCustomers(subCustomerOptions)
      }
    }
  }, [userType, itemIdForUpdate, user?.code, user.fK_Customer, user.customerName, user.customerAccess, user.requesterSubcustomrs])

  useEffect(() => {
    if (userType !== 'CONSUMER') return
    const sessionKey = consumerSessionInitRef.current
    if (!sessionKey || consumerAccountsLoadedForSessionRef.current === sessionKey) {
      return
    }

    const primaryId =
      user.fK_Customer != null && user.fK_Customer !== ''
        ? Number(user.fK_Customer)
        : null
    const initialAssociated =
      user.customerAccess
        ?.filter((c) => primaryId == null || Number(c.code) !== primaryId)
        .map((c) => ({value: c.code, label: c.name})) ?? []

    const initialCustList: {value: any; label: string}[] = []
    if (primaryId != null && !isNaN(primaryId) && primaryId > 0) {
      initialCustList.push({
        value: primaryId,
        label: user.customerName || `Customer #${primaryId}`,
      })
    }
    initialAssociated.forEach((c) => {
      if (!initialCustList.some((p) => String(p.value) === String(c.value))) {
        initialCustList.push(c)
      }
    })

    if (initialCustList.length === 0) {
      return
    }

    if (editLookups?.subAccounts?.length) {
      populateCustomerGroupsFromSubAccounts(initialCustList, editLookups.subAccounts)
      consumerAccountsLoadedForSessionRef.current = sessionKey
      return
    }

    if (editLookups === undefined && itemIdForUpdate) {
      return
    }

    consumerAccountsLoadedForSessionRef.current = sessionKey
    void fetchAndSetCustomerAccountsMulti(initialCustList)
  }, [userType, itemIdForUpdate, user?.code, user.fK_Customer, user.customerName, user.customerAccess, editLookups])

  useEffect(() => {
    if (userType === 'INTERPRETER' || userType === 'SYSTEM') {
      formik.setFieldValue('pinCode', 99999999)
    }
  }, [userType])

  const [data, setData] = useState(userForEdit)
  const [preCallPolicies, setPreCallPolicies] = useState<{value: any; label: string}[]>([])
  const {
    mutate: refetchPreCallQuestion,
    isLoading: isPreCallQuestionLoading,
  } = useMutation(getAllPreCallQuestionByCustomer, {
    onSuccess: (resData) => {
      if (resData) {
        setPreCallPolicies(
          resData.map((d) => ({
            value: d.value ?? '',
            label: d.label ?? d.value ?? '',
          }))
        )
      }
    },
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
    formik.resetForm()
    hiddenFileInput.current.value = null // Clear the file input
  }

  const fetchSubCustomerOptions = async (customerId: string, customerLabel: string) => {
    const parentCustomerOption = {
      value: customerId,
      label: customerLabel + ' - parent',
      id: customerId,
    };
    const response = await axios.get<{ data: any[] }>(
      `${process.env.REACT_APP_API_URL}/customer/${customerId}/sub-accounts/shortlist`
    );
    const options = (response.data.data || []).map((d: any) => ({
      value: d.key,
      label: d.value,
      id: d.key,
    }));
    return [parentCustomerOption, ...options];
  };

  const fetchSubcustomers = async (customerId: string) => {
    formik.setSubmitting(true);
    try {
      setSubCustomers(await fetchSubCustomerOptions(customerId, user.customerName || ''));
    } catch (err) {
      console.error('Error fetching sub‑accounts:', err);
    } finally {
      formik.setSubmitting(false);
    }
  };


  const {
    isFetching: isPinCodeGenerated,
    data: pinDataLoad,
    refetch: pinrefetch,
  } = useQuery(
    `PINCODE_GENERATE`,
    () => {
      const result = GetPinCode()
      setIsGenPinCode(true)
      return result
    },
    {
      cacheTime: 0,
      enabled: false,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        // Clear the availability status data when a new pin code is generated
        removeAvailabilityStatus()
      },
    }
  )

  const {data: nativeLanguageList, isLoading: isFetchingNativeLanguage} = useLanguages()
  const {data: timeZoneList, isLoading: isFetchingTimeZone} = useTimeZones()

  const languageOptions = !isFetchingNativeLanguage && nativeLanguageList
    ? nativeLanguageList.map((d: any) => ({
        value: d.key,
        label: d.value,
      }))
    : []

  const TimezoneOptions = !isFetchingTimeZone && timeZoneList
    ? timeZoneList.map((d: any) => ({
        value: d.code,
        label: d.name,
      }))
    : []

  const {
    isFetching: isCheckAvailabilty,
    data: availabilityStatus,
    refetch: fn_CheckAvailabilty,
    remove: removeAvailabilityStatus,
  } = useQuery(
    `CHECK_AVAILAIBILTY`,
    () => {
      const result = CheckPinAvailability(newPinCode ?? '')
      return result
    },
    {cacheTime: 0, enabled: false, refetchOnWindowFocus: false}
  )

  useEffect(() => {
    if (newPinCode) {
      if (newPinCode && newPinCode.length >= 4 && newPinCode.length <= 10) {
        fn_CheckAvailabilty()
      } else {
        removeAvailabilityStatus()
      }
    }
  }, [newPinCode])

  useEffect(() => {
    if (pinDataLoad) {
      formik.setFieldValue('pinCode', pinDataLoad?.data?.toString() ?? 0)
      formik.setFieldValue('pinCodeString', pinDataLoad?.data?.toString() ?? 0)
    }
  }, [pinDataLoad])

  const GeneratePinCode = (withRefresh?: boolean) => {
    pinrefetch()
  }

  const updateData = async (option: any) => {
    setData((prev) => ({...prev, fK_Customer: option.value}))
    if (userType === 'CONSUMER') {
      return option.value
    }

    const getallShortlistedLocations = axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/customer/${option.value}/location/getall-shortlist`,
    })
    formik.setSubmitting(true)
    const getSubCustomers = axios.get(
      `${process.env.REACT_APP_API_URL}/customer/${option.value}/sub-accounts/shortlist`
    )

    axios
      .all([getallShortlistedLocations, getSubCustomers])
      .then(
        axios.spread((locRes, subRes) => {
          setCustomerLocation(locRes?.data.data)
          const parentCustomerOption = {
            value: option.value,
            label: (option.label || '') + ' - parent',
            id: option.value,
          }
          const subCustomerOptions = (subRes?.data?.data || []).map((d: any) => ({
            value: d.key,
            label: d.value,
            id: d.key,
          }))
          setSubCustomers([parentCustomerOption, ...subCustomerOptions])
          formik.setSubmitting(false)
        })
      )
      .catch(function (error) {})
    setSelectedSubCustomers([])
    return option.value
  }

  const {data: responseGenderMaster, isLoading: isFetchingGender} = useGenders()

  const {data: responseConsumerCustomers, isLoading: isFetchingConsumerCustomers} = useCustomers({
    enabled: userType === 'CONSUMER',
  })
  const {data: responseCustomerShortlist, isLoading: isFetchingRoleCustomers} = useQuery(
    [`user-edit-customers-${userType}`, customerCode],
    () => getCustomers(userType, customerCode ?? 0),
    {
      enabled: userType === 'SYSTEM' || userType === 'INTERPRETER',
      staleTime: 10 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  )

  const {isFetching, data: response} = useQuery(
    [`${roleQUERIES.Role_LIST}`, userType],
    () => {
      return getUserroles(userType)
    },
    {staleTime: 10 * 60 * 1000, cacheTime: 30 * 60 * 1000, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  useEffect(() => {
    if (response !== undefined) {
      if (response.data !== undefined) {
        if (response.data.length > 0) {
          if (itemIdForUpdate) {
            setUserForEdit({...userForEdit})
          } else {
            setUserForEdit({...userForEdit, role: response.data[0].name})
          }
        }
      }
    }
  }, [response])

  const handlePinCodeChange = (e: any) => {
    formik.setFieldValue('pinCode', e.target.value)
    formik.setFieldValue('pinCodeString', e.target.value.toString())
    setIsGenPinCode(false)
    getAvailability(e.target.value.toString())
  }

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const userAvatarImg = toAbsoluteUrl(`/media/${userForEdit.avatar}`)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...userForEdit,
      customerIds:
        user.customerAccess
          ?.filter(
            (c) =>
              user.fK_Customer == null ||
              String(c.code) !== String(user.fK_Customer)
          )
          .map((c) => Number(c.code)) ?? [],
      subCustomers:
        user.requesterSubcustomrs?.map((sub: any) => ({
          value: sub.code,
          label: sub.name,
          id: sub.code,
        })) ?? [],
      deactivationReason: '',
    },
    validationSchema: editUserSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const formData = new FormData()
      formData.append('firstName', values?.firstName ?? '')
      formData.append('lastName', values?.lastName ?? '')
      formData.append('phoneNumber', values.phoneNumber ?? '')
      formData.append('email', values.email ?? '')
      formData.append('fK_Gender', values.fK_Gender ?? '')

      if (userType === 'CONSUMER') {
        const primaryCustomer = values.fK_Customer || data.fK_Customer || ''
        formData.append('fK_Customer', primaryCustomer ? primaryCustomer.toString() : '')
        selectedCustomers.forEach((cust: any) => {
          if (String(cust.value) !== String(primaryCustomer)) {
            formData.append('CustomerIds', cust.value.toString())
          }
        })
        if (values.subCustomers && values.subCustomers.length > 0) {
          values.subCustomers.forEach((sub: any) => {
            if (String(sub.value) !== String(primaryCustomer)) {
              formData.append('SubCustomerIds', sub.value.toString())
            }
          })
        }
      } else {
        formData.append('fK_Customer', data.fK_Customer ?? '')
      }

      formData.append('fK_Location', values.fK_Location ?? '')
      formData.append('fK_ServiceType', values.fK_ServiceType ?? '')
      formData.append('serviceTypes', values.serviceTypes.map((i: any) => i.value) ?? '')
      formData.append(
        'secondaryOpiServiceTypes',
        (values.secondaryOpiServiceTypes || []).map((i: any) => i.value).join(',')
      )
      formData.append('fk_PreCallPolicy', values.fK_PreCallPolicy ?? '')
      formData.append('fK_DefaultNativeLanguage', values.fK_DefaultNativeLanguage ?? '')
      formData.append('fK_DefaultTimeZone', values.fK_DefaultTimeZone ?? '')
      formData.append('role', values.role ?? '')
      formData.append('accessBilling', values.accessBilling ? "true" : "false")
      formData.append('recieveAllEmails', values.recieveAllEmails ? "true" : "false")
      formData.append('recieveUserEmails', values.recieveUserEmails ? "true" : "false")

      if (values.lockoutEnabled + '' === 'true' || values.lockoutEnabled + '' == 'false') {
        formData.append('lockoutEnabled', JSON.parse(values.lockoutEnabled + ''))
      }
      if (isDeactivating) {
        formData.append('deactivationReason', values.deactivationReason)
      }
      // formData.append('fK_DefaultTimeZone', values.fK_DefaultTimeZone ?? "");
      // formData.append('fK_DefaultNativeLanguage', values.fK_DefaultNativeLanguage ?? "");
      formData.append('city', values?.city ?? '')

      if (userType === 'INTERPRETER' || userType === 'SYSTEM') {
        formData.append('pinCode', '0')
      } else {
        if (values.pinCode == undefined || values.pinCode == null || values.pinCode + '' == '') {
          formData.append('pinCode', '0')
        } else {
          formData.append('pinCode', (values?.pinCode ?? 0).toString())
          formData.append('pinCodeString', (values?.pinCode ?? 0).toString())
        }
      }

      formData.append('address', values?.address ?? '')
      formData.append('street1', values?.street1 ?? '')
      formData.append('street2', values?.street2 ?? '')
      formData.append('state', values?.state ?? '')
      formData.append('country', values?.country ?? '')
      formData.append('postalCode', values?.postalCode ?? '')
      formData.append('latitude', values.latitude ?? '0')
      formData.append('longitude', values.longitude ?? '0')
      formData.append('profileImageFile', selectedFile ?? '')
      formData.append('ProfileImage', values?.profileImage ?? '')
      formData.append('code', values.code + '')
      formData.append('userType', userType)
      formData.append('password', values?.password ?? '')
      formData.append('setPassword', values.setPassword ? "true" : "false")

      if (
        values.isNewPasswordGenerate + '' === 'true' ||
        values.isNewPasswordGenerate + '' == 'false'
      ) {
        formData.append('isNewPasswordGenerate', JSON.parse(values.isNewPasswordGenerate + ''))
      } else {
        formData.append('isNewPasswordGenerate', 'false')
      }

      const shouldSendCallPermissions =
        userType !== 'INTERPRETER' || !isNotEmpty(values.code)

      if (shouldSendCallPermissions) {
        if (values.opI_ShdTelephonic + '' === 'true' || values.opI_ShdTelephonic + '' == 'false') {
          formData.append('oPI_ShdTelephonic', JSON.parse(values.opI_ShdTelephonic + ''))
        } else {
          formData.append('oPI_ShdTelephonic', 'false')
        }

        if (
          values.opI_OndemandTelephonic + '' === 'true' ||
          values.opI_OndemandTelephonic + '' == 'false'
        ) {
          formData.append('oPI_OndemandTelephonic', JSON.parse(values.opI_OndemandTelephonic + ''))
        } else {
          formData.append('oPI_OndemandTelephonic', 'false')
        }

        if (
          values.vrI_ShdVideoInteroreting + '' === 'true' ||
          values.vrI_ShdVideoInteroreting + '' == 'false'
        ) {
          formData.append(
            'vRI_ShdVideoInteroreting',
            JSON.parse(values.vrI_ShdVideoInteroreting + '')
          )
        } else {
          formData.append('vRI_ShdVideoInteroreting', 'false')
        }

        if (
          values.vrI_OndemandVideoInteroreting + '' === 'true' ||
          values.vrI_OndemandVideoInteroreting + '' == 'false'
        ) {
          formData.append(
            'vRI_OndemandVideoInteroreting',
            JSON.parse(values.vrI_OndemandVideoInteroreting + '')
          )
        } else {
          formData.append('vRI_OndemandVideoInteroreting', 'false')
        }
        if (
          values.osI_OnsiteConsecutive + '' === 'true' ||
          values.osI_OnsiteConsecutive + '' == 'false'
        ) {
          formData.append('oSI_OnsiteConsecutive', JSON.parse(values.osI_OnsiteConsecutive + ''))
        } else {
          formData.append('oSI_OnsiteConsecutive', 'false')
        }

        if (
          values.osI_OnsiteSimultaneous + '' === 'true' ||
          values.osI_OnsiteSimultaneous + '' == 'false'
        ) {
          formData.append('oSI_OnsiteSimultaneous', JSON.parse(values.osI_OnsiteSimultaneous + ''))
        } else {
          formData.append('oSI_OnsiteSimultaneous', 'false')
        }

        if (values.osI_OnsiteWhisper + '' === 'true' || values.osI_OnsiteWhisper + '' == 'false') {
          formData.append('oSI_OnsiteWhisper', JSON.parse(values.osI_OnsiteWhisper + ''))
        } else {
          formData.append('oSI_OnsiteWhisper', 'false')
        }

        if (values.osI_Onsite + '' === 'true' || values.osI_Onsite + '' == 'false') {
          formData.append('oSI_Onsite', JSON.parse(values.osI_Onsite + ''))
        } else {
          formData.append('oSI_Onsite', 'false')
        }

        if (
          values.other_3rdPartyPlatform + '' === 'true' ||
          values.other_3rdPartyPlatform + '' == 'false'
        ) {
          formData.append('other_3rdPartyPlatform', JSON.parse(values.other_3rdPartyPlatform + ''))
        } else {
          formData.append('other_3rdPartyPlatform', 'false')
        }

        if (values.translations + '' === 'true' || values.translations + '' == 'false') {
          formData.append('translations', JSON.parse(values.translations + ''))
        } else {
          formData.append('translations', 'false')
        }
      }

      // Add Linguist Type and Payable Type
      formData.append('linguistType', (values.linguistType ?? 0).toString())
      formData.append('payableType', (values.payableType ?? 0).toString())

      if (userType === 'INTERPRETER' && isAdmin) {
        formData.append(
          'isAllowedMobileLogin',
          values.isAllowedMobileLogin ? 'true' : 'false'
        )
      }

      setSubmitting(true)
      try {
        if (isNotEmpty(values.code)) {
          var result: any = await updateUser(formData)
          if (result?.status === 'S') {
            if (currentUser?.result?.code === result?.result) {
              const {data: user} = await getUserByToken()
              setCurrentUser(user)
            }
            toaster('success', result?.text ?? 'Record Updated')
          } else if (result?.status == 'E') {
            toaster('error', result?.text ?? 'Record Not Updated')
          }
        } else {
          var res = await createUser(formData)
          if (res?.status == 'S') {
            toaster('success', res?.text ?? 'Record Updated')
          } else if (res?.status == 'E') {
            toaster('error', res?.text ?? 'Record Not Updated')
          }
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  const isDeactivating =
    String(user.lockoutEnabled) !== 'true' && String(formik.values.lockoutEnabled) === 'true'

  const isFetchingServiceType = false
  const refetchService = () => {}
  const serviceOptions = consumerServiceOptions

  const fetchCompanyLocationsAndServiceTypes = (customerId: number | string) => {
    const code = Number(customerId)
    if (userType !== 'CONSUMER' || isNaN(code) || code <= 0) {
      return
    }
    getCustomerLocationsMulti([code])
      .then((res) => setCustomerLocation(res?.data ?? []))
      .catch(() => setCustomerLocation([]))

    getServiceTypeByCustomerCode('SERVICE_TYPE', code)
      .then((res) => {
        const rows = res?.data ?? []
        setConsumerServiceOptions(
          rows.map((d: any) => ({
            value: d.key,
            label: d.value,
          }))
        )
      })
      .catch(() => setConsumerServiceOptions([]))

    refetchPreCallQuestion(String(code))
  }

  // Debounce function to handle API call
  const debouncedApiCall = useCallback(
    debounce(async (value) => {
      try {
        if (value != null) {
          var result = await checkUserEmail(value, userType)
          if (result?.status === 'E') {
            formik.setFieldValue('email', '')
            toaster('error', `'${value}' already exsists`)
          }
        }
      } catch (error) {
        formik.setFieldError('email', 'Required') // Set Formik error based on API response
      }
    }, 2000), // 500ms debounce delay
    []
  )

  const handleChange = (e: any, isError: any) => {
    formik.handleChange(e)
    if (isError === false) debouncedApiCall(e.target.value)
  }

  useEffect(() => {
    if (!selectedFile) {
      setPreview('')
      return
    }

    const objectUrl = URL.createObjectURL(selectedFile)
    setPreview(objectUrl)

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl)
  }, [selectedFile])

  const onSelectFile = (e: any) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined)
      return
    }

    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        formik.setFieldValue('profileImage', reader.result)
        formik.setFieldTouched('profileImage', true, true)
      }
      reader.readAsDataURL(file)
    }

    setSelectedFile(file)
  }

  const genderOptions =
    !isFetchingGender && responseGenderMaster
      ? responseGenderMaster
          .filter((d: any) => d.identification !== 'A')
          .map((d) => ({value: d.key, label: d.value}))
      : []

  const linguistTypeOptions = [
    {value: 0, label: 'Interpreter'},
    {value: 1, label: 'Translator'},
  ]

  const payableTypeOptions = [
    {value: 0, label: 'Hourly'},
    {value: 1, label: 'Minute - Freelance'},
  ]

  const customerOptions = useMemo(() => {
    if (userType === 'CONSUMER') {
      const base =
        !isFetchingConsumerCustomers && responseConsumerCustomers
          ? responseConsumerCustomers.map((d) => ({value: d.key, label: d.value}))
          : []
      const merged = [...base]
      const primaryId = formik.values.fK_Customer ?? user.fK_Customer
      if (primaryId != null && primaryId !== '') {
        const primaryKey = String(primaryId)
        if (!merged.some((o) => String(o.value) === primaryKey)) {
          merged.unshift({
            value: primaryId,
            label:
              user.customerName ||
              (String(user.fK_Customer) === primaryKey ? user.customerName : undefined) ||
              `Customer #${primaryId}`,
          })
        }
      }
      return merged
    }
    if (userType === 'INTERPRETER') {
      if (itemIdForUpdate && user.fK_Customer) {
        return [
          {
            value: String(user.fK_Customer),
            label: user.customerName || `Customer #${user.fK_Customer}`,
          },
        ]
      }
      return !isFetchingRoleCustomers && responseCustomerShortlist?.data
        ? responseCustomerShortlist.data.map((d) => ({value: d.key, label: d.value}))
        : []
    }
    return !isFetchingRoleCustomers && responseCustomerShortlist?.data
      ? responseCustomerShortlist.data.map((d) => ({value: d.key, label: d.value}))
      : []
  }, [
    userType,
    isFetchingConsumerCustomers,
    responseConsumerCustomers,
    isFetchingRoleCustomers,
    responseCustomerShortlist?.data,
    formik.values.fK_Customer,
    user.fK_Customer,
    user.customerName,
    itemIdForUpdate,
  ])

  const availableCustomerOptions = customerOptions.filter((opt) => {
    if (String(opt.value) === String(formik.values.fK_Customer)) return false
    const isAlreadySelected = selectedCustomers.some(
      (c) => String(c.value) === String(opt.value)
    )
    if (isAlreadySelected) return false
    if (!customerSearch) return true
    return (opt.label ?? '').toLowerCase().includes(customerSearch.toLowerCase())
  })

  /** Primary company (FK_Customer) plus associated customers — drives applicable accounts like before. */
  const primaryCompanyCustomer = useMemo(() => {
    if (userType !== 'CONSUMER') return null
    const fk = formik.values.fK_Customer
    if (fk == null || fk === '') return null
    const label =
      customerOptions.find((o) => String(o.value) === String(fk))?.label ||
      (String(user.fK_Customer) === String(fk) ? user.customerName : undefined) ||
      `Customer #${fk}`
    return {value: fk, label: label ?? `Customer #${fk}`}
  }, [userType, formik.values.fK_Customer, customerOptions, user.fK_Customer, user.customerName])

  const customersForAccountGrouping = useMemo(() => {
    const list: {value: any; label: string}[] = []
    if (primaryCompanyCustomer) {
      list.push(primaryCompanyCustomer)
    }
    for (const c of selectedCustomers) {
      if (
        primaryCompanyCustomer &&
        String(c.value) === String(primaryCompanyCustomer.value)
      ) {
        continue
      }
      list.push(c)
    }
    return list
  }, [primaryCompanyCustomer, selectedCustomers])

  const hasConsumerCustomerContext =
    !!primaryCompanyCustomer || selectedCustomers.length > 0

  /** Parent company row is fixed when that customer is Company or Associated Customers. */
  const isParentAccountLocked = (customerId: any) => {
    const id = String(customerId)
    if (formik.values.fK_Customer != null && String(formik.values.fK_Customer) === id) {
      return true
    }
    return selectedCustomers.some((c) => String(c.value) === id)
  }

  const lockedParentSelections = useMemo(
    () =>
      customersForAccountGrouping.map((c) => ({
        value: c.value,
        label: c.label,
        id: c.value,
      })),
    [customersForAccountGrouping]
  )

  const updateApplicableSubCustomers = useCallback(
    (next: any[]) => {
      formik.setFieldValue(
        'subCustomers',
        withLockedParentAccounts(next, lockedParentSelections)
      )
    },
    [formik, lockedParentSelections]
  )

  const getSubAccountsForCustomer = (customerId: any): AccountItem[] => {
    const group = customerGroups[String(customerId)]
    return group?.subAccounts ?? []
  }

  const handlePrimaryCustomerChange = (option: {value: any; label: string} | null) => {
    const nextValue = option?.value != null && option.value !== '' ? String(option.value) : ''
    const prevPrimary = String(formik.values.fK_Customer ?? '')
    if (nextValue && selectedCustomers.some((c) => String(c.value) === nextValue)) {
      handleRemoveCustomer(nextValue)
    }
    formik.setFieldValue('fK_Customer', nextValue)
    setData((prev) => ({...prev, fK_Customer: nextValue}))
    if (
      userType === 'CONSUMER' &&
      prevPrimary &&
      nextValue &&
      prevPrimary !== nextValue
    ) {
      const oldGroup = customerGroups[prevPrimary]
      const oldAccountIds = new Set(
        oldGroup
          ? oldGroup.allAccounts.map((a) => String(a.value))
          : [prevPrimary]
      )
      const keptSub = (formik.values.subCustomers || []).filter(
        (s: any) => !oldAccountIds.has(String(s.value))
      )
      updateApplicableSubCustomers(keptSub)
    }
    if (option?.value) {
      updateData(option)
      fetchCompanyLocationsAndServiceTypes(option.value)
      formik.setFieldValue('serviceTypes', [])
      formik.setFieldValue('secondaryOpiServiceTypes', [])
      formik.setFieldValue('fK_ServiceType', '')
      formik.setFieldValue('fK_Location', '')
      setExpandedCustomers((prev) => ({...prev, [String(option.value)]: true}))
      void fetchAndSetCustomerAccounts(option.value, option.label ?? '').then((accounts) => {
        if (userType !== 'CONSUMER' || !accounts?.length) return
        const currentSub = formik.values.subCustomers || []
        const merged = [...currentSub]
        for (const a of accounts) {
          if (!merged.some((s: any) => String(s.value) === String(a.value))) {
            merged.push({
              value: a.value,
              label: a.label,
              id: a.id ?? a.value,
            })
          }
        }
        updateApplicableSubCustomers(merged)
      })
    }
  }

  const handleAddCustomer = async (option: {value: any; label: string}) => {
    if (String(option.value) === String(formik.values.fK_Customer)) {
      return
    }
    if (selectedCustomers.some((c) => String(c.value) === String(option.value))) {
      return
    }
    const newSelectedCustomers = [...selectedCustomers, option]
    setSelectedCustomers(newSelectedCustomers)
    setCustomerSearch('')
    setIsCustomerDropdownOpen(false)

    setExpandedCustomers((prev) => ({...prev, [String(option.value)]: true}))

    const allAccounts = await fetchAndSetCustomerAccounts(
      option.value,
      option.label ?? ''
    )

    const currentSub = formik.values.subCustomers || []
    const merged = [...currentSub]
    for (const a of allAccounts) {
      if (!merged.some((s: any) => String(s.value) === String(a.value))) {
        merged.push({
          value: a.value,
          label: a.label,
          id: a.id ?? a.value,
        })
      }
    }
    updateApplicableSubCustomers(merged)
    formik.setFieldValue('customerIds', newSelectedCustomers.map((c) => Number(c.value)))
  }

  const handleRemoveCustomer = (customerId: any) => {
    const newSelectedCustomers = selectedCustomers.filter(
      (c) => String(c.value) !== String(customerId)
    )
    setSelectedCustomers(newSelectedCustomers)

    const group = customerGroups[String(customerId)]
    const groupAccountValues = new Set(
      group ? group.allAccounts.map((a) => String(a.value)) : [String(customerId)]
    )
    const updatedSub = (formik.values.subCustomers || []).filter(
      (s: any) => !groupAccountValues.has(String(s.value))
    )
    updateApplicableSubCustomers(updatedSub)
    formik.setFieldValue('customerIds', newSelectedCustomers.map((c) => Number(c.value)))

    setCustomerGroups((prev) => {
      const next = {...prev}
      delete next[String(customerId)]
      return next
    })
  }

  const isAccountSelected = (accountValue: any) => {
    return (formik.values.subCustomers || []).some(
      (s: any) => String(s.value) === String(accountValue)
    )
  }

  const handleToggleAccount = (account: AccountItem) => {
    const customerId = account.customerId ?? account.value
    if (account.isParent && isParentAccountLocked(customerId)) {
      return
    }
    const currentSub = formik.values.subCustomers || []
    const exists = currentSub.some((s: any) => String(s.value) === String(account.value))
    let updatedSub: any[]
    if (exists) {
      updatedSub = currentSub.filter((s: any) => String(s.value) !== String(account.value))
    } else {
      updatedSub = [...currentSub, {value: account.value, label: account.label, id: account.id}]
    }
    updateApplicableSubCustomers(updatedSub)
  }

  const handleToggleCustomerGroup = (customerId: any) => {
    const group = customerGroups[String(customerId)]
    const subAccounts = group?.subAccounts ?? getSubAccountsForCustomer(customerId)
    const parentLocked = isParentAccountLocked(customerId)
    const parentEntry = {
      value: customerId,
      label: group?.customerName ?? customersForAccountGrouping.find(
        (c) => String(c.value) === String(customerId)
      )?.label ?? `Customer #${customerId}`,
      id: customerId,
    }

    const currentSub = formik.values.subCustomers || []
    const subValues = new Set(subAccounts.map((a) => String(a.value)))
    const selectedSubCount = currentSub.filter((s: any) => subValues.has(String(s.value))).length

    let updatedSub: any[]
    if (subAccounts.length > 0 && selectedSubCount === subAccounts.length) {
      updatedSub = currentSub.filter((s: any) => !subValues.has(String(s.value)))
      if (parentLocked && !updatedSub.some((s: any) => String(s.value) === String(customerId))) {
        updatedSub.push(parentEntry)
      }
    } else {
      const nonGroupSubs = currentSub.filter((s: any) => !subValues.has(String(s.value)))
      const subsToAdd = subAccounts.map((a) => ({
        value: a.value,
        label: a.label,
        id: a.id,
      }))
      updatedSub = [...nonGroupSubs, ...subsToAdd]
      if (
        parentLocked &&
        !updatedSub.some((s: any) => String(s.value) === String(customerId))
      ) {
        updatedSub.push(parentEntry)
      }
    }
    updateApplicableSubCustomers(updatedSub)
  }

  const allToggleableSubAccounts: AccountItem[] = customersForAccountGrouping.flatMap((c) =>
    getSubAccountsForCustomer(c.value)
  )

  const isAllMasterChecked =
    allToggleableSubAccounts.length === 0
      ? customersForAccountGrouping.length > 0
      : allToggleableSubAccounts.every((a) =>
          (formik.values.subCustomers || []).some(
            (s: any) => String(s.value) === String(a.value)
          )
        )
  const isMasterIndeterminate =
    allToggleableSubAccounts.length > 0 &&
    !isAllMasterChecked &&
    allToggleableSubAccounts.some((a) =>
      (formik.values.subCustomers || []).some((s: any) => String(s.value) === String(a.value))
    )

  const handleToggleMasterAll = () => {
    const lockedIds = new Set(lockedParentSelections.map((p) => String(p.value)))
    const currentSub = formik.values.subCustomers || []

    if (isAllMasterChecked) {
      const kept = currentSub.filter((s: any) => lockedIds.has(String(s.value)))
      updateApplicableSubCustomers(kept)
      if (userType === 'CONSUMER') {
        formik.setFieldValue('serviceTypes', [])
        formik.setFieldValue('fK_ServiceType', '')
        formik.setFieldValue('secondaryOpiServiceTypes', [])
      }
    } else {
      const subToSelect = allToggleableSubAccounts.map((a) => ({
        value: a.value,
        label: a.label,
        id: a.id,
      }))
      const nonSubs = currentSub.filter(
        (s: any) =>
          lockedIds.has(String(s.value)) ||
          !allToggleableSubAccounts.some((a) => String(a.value) === String(s.value))
      )
      const merged = [...nonSubs]
      for (const sub of subToSelect) {
        if (!merged.some((s: any) => String(s.value) === String(sub.value))) {
          merged.push(sub)
        }
      }
      updateApplicableSubCustomers(merged)
    }
  }

  const toggleCustomerExpand = (customerId: any) => {
    setExpandedCustomers((prev) => ({
      ...prev,
      [String(customerId)]: !prev[String(customerId)],
    }))
  }

  const locationOptions = customerLocation
    ? customerLocation.map((d) => ({value: d.key, label: d.value}))
    : []
  const preCallPolicyOptions = preCallPolicies
    ? preCallPolicies.map((d) => ({value: d.value, label: d.label}))
    : []
  const isPinCodeError =
    typeof formik.errors.pinCode === 'string' && formik.errors.pinCode.length > 0

  const handleSelect = async (address: string) => {
    try {
      const results = await geocodeByAddress(address)
      const placeDetails = await getLatLng(results[0])

      // Extract detailed address components
      let street1 = ''
      let street2 = ''
      let city = ''
      let state = ''
      let country = ''
      let postalCode = ''

      results[0].address_components.forEach((component) => {
        if (component.types.includes('street_number')) {
          street1 = component.long_name
        } else if (component.types.includes('route')) {
          street2 = component.long_name
        } else if (component.types.includes('locality')) {
          city = component.long_name
        } else if (component.types.includes('administrative_area_level_1')) {
          state = component.long_name
        } else if (component.types.includes('country')) {
          country = component.long_name
        } else if (component.types.includes('postal_code')) {
          postalCode = component.long_name
        }
      })

      formik.setFieldValue('address', address)
      formik.setFieldValue('street1', street1)
      formik.setFieldValue('street2', street2)
      formik.setFieldValue('city', city)
      formik.setFieldValue('state', state)
      formik.setFieldValue('country', country)
      formik.setFieldValue('postalCode', postalCode)
      formik.setFieldValue('latitude', placeDetails.lat)
      formik.setFieldValue('longitude', placeDetails.lng)

      // Select the input element with id "city"
      const cityInputElement = document.querySelector<HTMLInputElement>('#city')

      // Ensure the cityInputElement exists before focusing on it
      if (cityInputElement) {
        cityInputElement.focus() // Focuses on the input field
      }
    } catch (error) {
      console.error('Error fetching place details', error)
    }
  }

  const renderFunc: React.FC<RenderFuncProps> = ({
    getInputProps,
    getSuggestionItemProps,
    suggestions,
    loading,
    error,
  }) => (
    <div className='autocomplete-root'>
      <input
        className={clsx('form-control form-control-sm form-control-light custom-input-height')}
        disabled={formik.isSubmitting || isUserLoading}
        placeholder='Address'
        {...getInputProps()}
      />
      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{error}</span>
          </div>
        </div>
      )}
      <div className='autocomplete-dropdown-container'>
        {loading && <div>Loading...</div>}
        {suggestions.map((suggestion: any) => (
          <div
            {...getSuggestionItemProps(suggestion)}
            key={suggestion.placeId}
            className='bg-light p-2 border border-bottom overflow-auto'
            style={{cursor: 'pointer'}}
          >
            <option>{suggestion.description}</option>
          </div>
        ))}
      </div>
    </div>
  )

  function getAvailability(pinCodeString: any) {
    setNewPinCode(pinCodeString)
  }

  return (
    <>
      <form
        id='kt_modal_add_user_form'
        className='modal-body'
        onSubmit={formik.handleSubmit}
        noValidate
      >
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7 px-1'
          style={{maxHeight: '75vh'}}
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='400px'
        >
          <div className='row g-4 g-xl-6'>
            <div className='col-sm-12 col-md-12 col-lg-12'>
              <div className=''>
                <div className='row g-4 g-xl-6'>
                  <ImageComponent
                    selectedFile={selectedFile}
                    onSelectFile={onSelectFile}
                    preview={preview}
                    profileImage={formik.values.profileImage}
                    type='Profile'
                    hiddenFileInput={hiddenFileInput}
                  />
                  <div className='col-sm-8 col-md-8 col-lg-8 '>
                    <div className='mb-3'>
                      <label
                        htmlFor='exampleFormControlInput1'
                        className='required form-label fs-7 mb-1 '
                      >
                        Name
                      </label>
                      <div className='d-flex align-items-center'>
                        <div className='row g-3 g-xl-4 flex-grow-1'>
                          <div className='col-sm-6 col-md-6 col-lg-6 '>
                            <input
                              placeholder='First Name'
                              {...formik.getFieldProps('firstName')}
                              type='text'
                              name='firstName'
                              className={clsx(
                                'form-control form-control-white form-select-sm custom-input-height'
                              )}
                              autoComplete='off'
                              disabled={formik.isSubmitting || isUserLoading}
                              onClick={() => {
                                if (userType === 'INTERPRETER' || userType === 'SYSTEM') {
                                  formik.setFieldValue('pinCode', 99999999)
                                }
                              }}
                            />
                            {formik.errors.firstName && formik.touched.firstName && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.firstName}</span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className='col-sm-6 col-md-6 col-lg-6 '>
                            <input
                              placeholder='Last name'
                              {...formik.getFieldProps('lastName')}
                              type='text'
                              name='lastName'
                              className={clsx(
                                'form-control form-control-white form-select-sm custom-input-height'
                              )}
                              autoComplete='off'
                              disabled={formik.isSubmitting || isUserLoading}
                            />
                            {formik.errors.lastName && formik.touched.lastName && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.lastName}</span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className='' hidden={!(userType === 'INTERPRETER' && true)}>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='required form-label fs-7 mb-1 '
                            >
                              Gender
                            </label>
                            <div className='col-sm-6 col-md-6 col-lg-6 '>
                              <Select
                                {...formik.getFieldProps('fK_Gender')}
                                name='fK_Gender'
                                placeholder='Select a Gender'
                                value={genderOptions.find(
                                  (option) => option.value === formik.values.fK_Gender
                                )}
                                onChange={(option: {value: any}) =>
                                  formik.setFieldValue('fK_Gender', option?.value || '')
                                }
                                isDisabled={formik.isSubmitting || isUserLoading}
                                options={genderOptions}
                                styles={{
                                  control: (provided: any) => ({
                                    ...provided,
                                    width: '100%',
                                    border: '1px solid #e4e6ef',
                                  }),
                                  placeholder: (provided: any) => ({
                                    ...provided,
                                    color: '#a4afc4',
                                  }),
                                }}
                                onBlur={() => formik.setFieldTouched('fK_Gender', true)}
                              />
                              {formik.errors.fK_Gender && formik.touched.fK_Gender && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.fK_Gender}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Linguist Type Field */}
                          <div className='' hidden={!(userType === 'INTERPRETER' && true)}>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='required form-label fs-7 mb-1 '
                            >
                              Linguist Type
                            </label>
                            <div className='col-sm-6 col-md-6 col-lg-6 '>
                              <Select
                                {...formik.getFieldProps('linguistType')}
                                name='linguistType'
                                placeholder='Select Linguist Type'
                                value={linguistTypeOptions.find(
                                  (option) => option.value === formik.values.linguistType
                                )}
                                onChange={(option: {value: any}) =>
                                  formik.setFieldValue('linguistType', option?.value !== undefined ? option.value : '')
                                }
                                isDisabled={formik.isSubmitting || isUserLoading}
                                options={linguistTypeOptions}
                                styles={{
                                  control: (provided: any) => ({
                                    ...provided,
                                    width: '100%',
                                    border: '1px solid #e4e6ef',
                                  }),
                                  placeholder: (provided: any) => ({
                                    ...provided,
                                    color: '#a4afc4',
                                  }),
                                }}
                                onBlur={() => formik.setFieldTouched('linguistType', true)}
                              />
                              {formik.errors.linguistType && formik.touched.linguistType && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.linguistType}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Payable Type Field */}
                          <div className='' hidden={!(userType === 'INTERPRETER' && true)}>
                            <label
                              htmlFor='exampleFormControlInput1'
                              className='required form-label fs-7 mb-1 '
                            >
                              Payable Type
                            </label>
                            <div className='col-sm-6 col-md-6 col-lg-6 '>
                              <Select
                                {...formik.getFieldProps('payableType')}
                                name='payableType'
                                placeholder='Select Payable Type'
                                value={payableTypeOptions.find(
                                  (option) => option.value === formik.values.payableType
                                )}
                                onChange={(option: {value: any}) =>
                                  formik.setFieldValue('payableType', option?.value !== undefined ? option.value : '')
                                }
                                isDisabled={formik.isSubmitting || isUserLoading}
                                options={payableTypeOptions}
                                styles={{
                                  control: (provided: any) => ({
                                    ...provided,
                                    width: '100%',
                                    border: '1px solid #e4e6ef',
                                  }),
                                  placeholder: (provided: any) => ({
                                    ...provided,
                                    color: '#a4afc4',
                                  }),
                                }}
                                onBlur={() => formik.setFieldTouched('payableType', true)}
                              />
                              {formik.errors.payableType && formik.touched.payableType && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.payableType}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                     <div className='mb-3 '>
                      <div className='row g-4 g-xl-6'>
                        <div className=''>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='required form-label fs-7 mb-1 '
                          >
                            Email
                          </label>
                          <input
                            placeholder='Email'
                            {...formik.getFieldProps('email')}
                            className={clsx(
                              'form-control form-control-white form-select-sm custom-input-height'
                            )}
                            type='email'
                            name='email'
                            autoComplete='off'
                            onChange={(e) =>
                              handleChange(
                                e,
                                formik.touched.email && !formik.errors.email ? true : false
                              )
                            }
                            disabled={
                              formik.isSubmitting || isUserLoading  ? true : false
                            }
                          />
                          {formik.errors.email && formik.touched.email && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.email}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                    <div className='mb-3 '>
                      <div className='row g-4 g-xl-6'>
                        <div className=''>
                            <div className='mb-2'>
                              <input
                                className='form-check-input me-2'
                                type='checkbox'
                                id='setPasswordCheckbox'
                                checked={formik.values.setPassword || false}
                                onChange={(e: { target: { checked: any } }) => {
                                  formik.setFieldValue('setPassword', e.target.checked);
                                  if (!e.target.checked) formik.setFieldValue('password', '');
                                }}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label className='form-check-label' htmlFor='setPasswordCheckbox'>Set Password</label>
                            </div>
                            {formik.values.setPassword && (
                              <input
                                placeholder='Set Password'
                                className={clsx(
                                  'form-control form-control-white form-select-sm custom-input-height'
                                )}
                                type='text'
                                name='password'
                                autoComplete='off'
                                value={formik.values.password || ''}
                                onChange={e => handleChange(e, false)}
                                disabled={formik.isSubmitting || isUserLoading}
                                style={{ minWidth: '200px' }}
                              />
                            )}
                            {formik.values.setPassword && formik.errors.password && formik.touched.password && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.password}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3'>
                      <div className='row g-4 g-xl-6'>
                        <div className='col-sm-6 col-md-6 col-lg-6 mb-5 '>
                          <label
                            htmlFor='exampleFormControlInput1'
                            className='form-label fs-7 mb-1 '
                          >
                            Contact Number
                          </label>
                          <PhoneInput
                            countryCallingCodeEditable={false}
                            international
                            defaultCountry='US'
                            id='phoneNumber'
                            name='phoneNumber'
                            value={formik.values.phoneNumber}
                            onBlur={() => formik.setFieldTouched('phoneNumber', true)}
                            onChange={(value) => {
                              formik.setFieldTouched('phoneNumber', true)
                              formik.setFieldValue('phoneNumber', value ? value : '')
                            }}
                            className={clsx(
                              'phoneNumber form-control form-control-white form-select-sm mb-2 custom-input-height'
                            )}
                          />
                          {/* Phone number validation removed */}
                        </div>
                        {/* <div className='col-sm-6 col-md-6 col-lg-6 d-flex align-items-center'>
                          <div className='form-check-custom form-check-white form-check-sm'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              value=''
                              id='flexCheckDefault'
                            />
                            <label
                              className='form-check-label form-check-sm'
                              htmlFor='flexCheckDefault'
                            >
                              Allow SMS Notifications
                            </label>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mb-3'>
                <label className='required form-label fs-7 mb-1 '>Address</label>
                {typeof window.google !== 'undefined' && (
                  <PlacesAutocomplete
                    onSelect={(address: any) => {
                      handleSelect(address)
                    }}
                    value={formik.values.address}
                    onChange={(e: any) => {
                      if (e === '') {
                        formik.setFieldValue('address', '')
                        formik.setFieldValue('street1', '')
                        formik.setFieldValue('street2', '')
                        formik.setFieldValue('city', '')
                        formik.setFieldValue('state', '')
                        formik.setFieldValue('country', '')
                        formik.setFieldValue('postalCode', '')
                        formik.setFieldValue('latitude', '')
                        formik.setFieldValue('longitude', '')
                      }
                      formik.setFieldValue('address', e)
                    }}
                  >
                    {({getInputProps, getSuggestionItemProps, suggestions, loading}) => (
                      <div>
                        {renderFunc({
                          getInputProps,
                          getSuggestionItemProps,
                          suggestions,
                          loading,
                          error: formik.errors.address,
                        })}
                      </div>
                    )}
                  </PlacesAutocomplete>
                )}
              </div>

              <div className='row g-4 mb-3'>
                <div className='col-lg-6 col-sm-12'>
                  <label className='required form-label fs-7 mb-1 '>City</label>
                  <div>
                    <input
                      placeholder='City'
                      {...formik.getFieldProps('city')}
                      type='text'
                      name='city'
                      id='city'
                      className={clsx(
                        'form-control form-control-sm form-control-light custom-input-height'
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isUserLoading}
                    />
                    {formik.errors.city && formik.touched.city && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.city}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                  <label className='required form-label fs-7 mb-1 '>State</label>
                  <div>
                    <input
                      placeholder='State'
                      {...formik.getFieldProps('state')}
                      type='text'
                      name='state'
                      id='state'
                      className={clsx(
                        'form-control form-control-sm form-control-light custom-input-height'
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isUserLoading}
                    />
                    {formik.errors.state && formik.touched.state && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.state}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                  <label className='required form-label fs-7 mb-1 '>Country</label>
                  <div>
                    <input
                      placeholder='Country'
                      {...formik.getFieldProps('country')}
                      type='text'
                      name='country'
                      id='country'
                      className={clsx(
                        'form-control form-control-sm form-control-light custom-input-height'
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isUserLoading}
                    />
                    {formik.errors.country && formik.touched.country && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.country}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                  <label className='required form-label fs-7 mb-1 '>Postal Code</label>
                  <div className=''>
                    <input
                      placeholder='Postal Code'
                      {...formik.getFieldProps('postalCode')}
                      type='text'
                      name='postalCode'
                      id='postalCode'
                      className={clsx(
                        'form-control form-control-sm form-control-light custom-input-height'
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isUserLoading}
                    />
                    {formik.errors.postalCode && formik.touched.postalCode && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.postalCode}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {formik.values.userType === 'CONSUMER' ? (
                <>
                  <div className='row g-4 mb-4'>
                    <div className='col-12 col-md-6'>
                      <label className='required form-label fs-7 mb-1'>Company Name</label>
                      <Select
                        name='fK_Customer'
                        placeholder='Select company'
                        value={customerOptions.find(
                          (option) => String(option.value) === String(formik.values.fK_Customer)
                        )}
                        onChange={(option: {value: any; label: string} | null) =>
                          handlePrimaryCustomerChange(option)
                        }
                        isDisabled={
                          formik.isSubmitting || isUserLoading || lockConsumerCustomerFields
                        }
                        options={customerOptions}
                        onBlur={() => formik.setFieldTouched('fK_Customer', true)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            width: '100%',
                            border: '1px solid #e4e6ef',
                          }),
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: '#a4afc4',
                          }),
                        }}
                      />
                      {formik.errors.fK_Customer && formik.touched.fK_Customer && (
                        <div className='d-block fv-plugins-message-container mt-1'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.fK_Customer}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Associated customers (user_customer_access) */}
                  <div className='row g-4 mb-4'>
                    <div className='col-12'>
                      <div className='d-flex justify-content-between align-items-center mb-1'>
                        <label className='form-label fs-7 mb-0'>Associated Customers</label>
                      </div>

                      <div
                        className='customer-multi-select-container'
                        ref={customerDropdownRef}
                        onClick={() => {
                          if (!lockConsumerCustomerFields) setIsCustomerDropdownOpen(true)
                        }}
                      >
                        {selectedCustomers.map((cust) => (
                          <span key={cust.value} className='customer-pill'>
                            <span>{cust.label}</span>
                            {!lockConsumerCustomerFields && (
                              <span
                                className='customer-pill-remove'
                                title='Remove customer'
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleRemoveCustomer(cust.value)
                                }}
                              >
                                <X size={14} />
                              </span>
                            )}
                          </span>
                        ))}

                        <input
                          type='text'
                          className='customer-input-inline'
                          placeholder={
                            selectedCustomers.length === 0
                              ? 'Select customers...'
                              : 'Add another customer...'
                          }
                          value={customerSearch}
                          onChange={(e) => {
                            setCustomerSearch(e.target.value)
                            setIsCustomerDropdownOpen(true)
                          }}
                          onFocus={() => {
                            if (!lockConsumerCustomerFields) setIsCustomerDropdownOpen(true)
                          }}
                          disabled={
                            formik.isSubmitting ||
                            isUserLoading ||
                            lockConsumerCustomerFields
                          }
                        />

                        {isCustomerDropdownOpen && !lockConsumerCustomerFields && (
                          <div className='customer-dropdown-menu'>
                            {availableCustomerOptions.length === 0 ? (
                              <div className='p-3 text-muted fs-8 text-center'>
                                {customerSearch ? 'No matching customers found' : 'All customers selected'}
                              </div>
                            ) : (
                              availableCustomerOptions.map((opt) => (
                                <div
                                  key={opt.value}
                                  className='customer-dropdown-item'
                                  onMouseDown={(e) => {
                                    e.preventDefault()
                                    handleAddCustomer({
                                      value: opt.value,
                                      label: opt.label ?? '',
                                    })
                                  }}
                                >
                                  {opt.label}
                                </div>
                              ))
                            )}
                          </div>
                        )}
                      </div>

                      {formik.errors.customerIds && formik.touched.customerIds && (
                        <div className='d-block fv-plugins-message-container mt-1'>
                          <div className='fv-help-block'>
                            <span role='alert'>{String(formik.errors.customerIds)}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Grouped Applicable Account(s) Section */}
                  <div className='row g-4 mb-4'>
                    <div className='col-12'>
                      <div className='d-flex justify-content-between align-items-center mb-1'>
                        <div className='d-flex align-items-center gap-2'>
                          <label className='form-label fs-7 mb-0'>Applicable Account(s)</label>
                          <span
                            className='badge'
                            style={{
                              backgroundColor: '#2e7d32',
                              color: '#ffffff',
                              fontSize: '10px',
                              fontWeight: 700,
                              padding: '2px 8px',
                              borderRadius: '4px',
                              letterSpacing: '0.5px',
                            }}
                          >
                            GROUPED BY CUSTOMER
                          </span>
                        </div>
                        <div className='form-check form-check-custom form-check-solid form-check-sm'>
                          <IndeterminateCheckbox
                            id='master-all-accounts'
                            className='cursor-pointer'
                            checked={isAllMasterChecked}
                            indeterminate={isMasterIndeterminate}
                            disabled={
                              formik.isSubmitting ||
                              isUserLoading ||
                              lockConsumerCustomerFields ||
                              customersForAccountGrouping.length === 0
                            }
                            onChange={handleToggleMasterAll}
                          />
                          <label
                            htmlFor='master-all-accounts'
                            className='form-check-label ms-2 fs-7 cursor-pointer'
                          >
                            All
                          </label>
                        </div>
                      </div>

                      <div className='applicable-accounts-card'>
                        {customersForAccountGrouping.length === 0 ? (
                          <div className='p-4 text-center text-muted fs-7'>
                            Select a company and/or associated customers to view applicable
                            accounts.
                          </div>
                        ) : (
                          customersForAccountGrouping.map((cust) => {
                            const group = customerGroups[String(cust.value)]
                            const isExpanded = !!expandedCustomers[String(cust.value)]
                            const subAccounts = group?.subAccounts ?? []
                            const parentLocked = isParentAccountLocked(cust.value)
                            const selectedSubCount = subAccounts.filter((acc) =>
                              isAccountSelected(acc.value)
                            ).length
                            const totalCount = subAccounts.length + (parentLocked ? 1 : 0)
                            const selectedCount =
                              selectedSubCount + (parentLocked && isAccountSelected(cust.value) ? 1 : 0)
                            const isGroupAllSelected =
                              totalCount > 0 && selectedCount === totalCount
                            const isGroupIndeterminate =
                              selectedCount > 0 && selectedCount < totalCount

                            return (
                              <div key={cust.value} className='applicable-account-group'>
                                <div
                                  className='applicable-account-header'
                                  onClick={() => toggleCustomerExpand(cust.value)}
                                >
                                  <div
                                    className='d-flex align-items-center'
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <IndeterminateCheckbox
                                      id={`cust-grp-${cust.value}`}
                                      checked={isGroupAllSelected}
                                      indeterminate={isGroupIndeterminate}
                                      disabled={
                                        formik.isSubmitting ||
                                        isUserLoading ||
                                        lockConsumerCustomerFields
                                      }
                                      onChange={() => handleToggleCustomerGroup(cust.value)}
                                    />
                                    <label
                                      htmlFor={`cust-grp-${cust.value}`}
                                      className='fw-bold text-gray-900 fs-7 ms-2 mb-0 cursor-pointer'
                                      onClick={() => toggleCustomerExpand(cust.value)}
                                    >
                                      {cust.label}
                                    </label>
                                  </div>
                                  <div className='d-flex align-items-center gap-2'>
                                    <span className='text-muted fs-8'>
                                      {selectedCount} of {totalCount} selected
                                    </span>
                                    {isExpanded ? (
                                      <ChevronUp size={16} className='text-gray-600' />
                                    ) : (
                                      <ChevronDown size={16} className='text-gray-600' />
                                    )}
                                  </div>
                                </div>

                                {isExpanded && (
                                  <div className='applicable-account-body'>
                                    {group?.isLoading ? (
                                      <div className='text-muted fs-8 py-2'>
                                        Loading accounts...
                                      </div>
                                    ) : (
                                      <>
                                        {/* Parent account item */}
                                        <div className='applicable-account-item'>
                                          <div className='form-check form-check-custom form-check-solid form-check-sm'>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id={`acc-${cust.value}`}
                                              checked={isAccountSelected(cust.value)}
                                              disabled={
                                                formik.isSubmitting ||
                                                isUserLoading ||
                                                lockConsumerCustomerFields ||
                                                parentLocked
                                              }
                                              onChange={() =>
                                                handleToggleAccount({
                                                  value: cust.value,
                                                  label: cust.label,
                                                  id: cust.value,
                                                  isParent: true,
                                                  customerId: cust.value,
                                                })
                                              }
                                            />
                                            <label
                                              className={`form-check-label ms-2 fs-7 text-gray-800 ${
                                                parentLocked ? '' : 'cursor-pointer'
                                              }`}
                                              htmlFor={`acc-${cust.value}`}
                                            >
                                              {cust.label}{' '}
                                              <span className='text-muted fst-italic fs-8'>
                                                (parent)
                                                {parentLocked ? ' — included with company' : ''}
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        {/* Sub-accounts items */}
                                        {subAccounts.map((sub) => (
                                          <div key={sub.value} className='applicable-account-item'>
                                            <div className='form-check form-check-custom form-check-solid form-check-sm'>
                                              <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id={`acc-${sub.value}`}
                                                checked={isAccountSelected(sub.value)}
                                                disabled={
                                                  formik.isSubmitting ||
                                                  isUserLoading ||
                                                  lockConsumerCustomerFields
                                                }
                                                onChange={() => handleToggleAccount(sub)}
                                              />
                                              <label
                                                className='form-check-label ms-2 fs-7 text-gray-800 cursor-pointer'
                                                htmlFor={`acc-${sub.value}`}
                                              >
                                                {sub.label}{' '}
                                                <span className='text-muted fst-italic fs-8'>
                                                  (sub-account)
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )
                          })
                        )}
                      </div>

                      {/* Summary row */}
                      {customersForAccountGrouping.length > 0 && (
                        <div className='d-flex flex-wrap align-items-center gap-2 mt-2'>
                          <span className='text-muted fs-7'>
                            {(formik.values.subCustomers || []).length} accounts selected across{' '}
                            {customersForAccountGrouping.length} customers:
                          </span>
                          {customersForAccountGrouping.map((cust) => {
                            const group = customerGroups[String(cust.value)]
                            const allAccounts = group?.allAccounts || [
                              {
                                value: cust.value,
                                label: cust.label,
                                id: cust.value,
                                isParent: true,
                                customerId: cust.value,
                              },
                            ]
                            const selectedCount = allAccounts.filter((acc) =>
                              isAccountSelected(acc.value)
                            ).length
                            return (
                              <span
                                key={cust.value}
                                className='account-summary-pill'
                                title={`${cust.label} (${selectedCount})`}
                              >
                                {cust.label} ({selectedCount})
                              </span>
                            )
                          })}
                        </div>
                      )}

                      {formik.errors.subCustomers && formik.touched.subCustomers && (
                        <div className='d-block fv-plugins-message-container mt-1'>
                          <div className='fv-help-block'>
                            <span role='alert'>{String(formik.errors.subCustomers)}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Office Location Row for CONSUMER */}
                  <div className='row g-4 mb-3'>
                    <div className='col-sm-12 col-md-6 col-lg-6'>
                      <label
                        htmlFor='exampleFormControlInput1'
                        className='required form-label fs-7 mb-1 '
                      >
                        Office Location
                      </label>
                      <div className='d-flex align-items-center'>
                        <div className='col-sm-12 col-md-12 col-lg-12'>
                          <Select
                            {...formik.getFieldProps('fK_Location')}
                            name='fK_Location'
                            className='mt-1'
                            placeholder='Select a location'
                            value={
                              locationOptions?.find(
                                (option) =>
                                  String(option.value) === String(formik.values.fK_Location)
                              ) ?? ''
                            }
                            onChange={(option: any) =>
                              formik.setFieldValue('fK_Location', option?.value || '')
                            }
                            isDisabled={
                              formik.isSubmitting ||
                              isUserLoading ||
                              !hasConsumerCustomerContext
                            }
                            options={locationOptions}
                            onBlur={() => formik.setFieldTouched('fK_Location', true)}
                            styles={{
                              control: (provided: any) => ({
                                ...provided,
                                width: '100%',
                                border: '1px solid #e4e6ef',
                              }),
                              placeholder: (provided: any) => ({
                                ...provided,
                                color: '#a4afc4',
                              }),
                            }}
                          />
                          {formik.errors.fK_Location && formik.touched.fK_Location && (
                            <div className='fv-plugins-message-container '>
                              <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.fK_Location}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                /* Non-CONSUMER: Standard single-customer and location dropdowns */
                <div className='row g-4 mb-3'>
                  <div className='col-sm-12 col-md-6 col-lg-6'>
                    <label className='required form-label fs-7 mb-1 '>
                      {userType === 'INTERPRETER' ? 'Company Name' : 'Customer'}
                    </label>
                    {userType === 'INTERPRETER' && itemIdForUpdate ? (
                      <input
                        type='text'
                        className='form-control form-control-sm form-control-light custom-input-height'
                        value={
                          user.customerName ||
                          customerOptions[0]?.label ||
                          (formik.values.fK_Customer
                            ? `Customer #${formik.values.fK_Customer}`
                            : '')
                        }
                        readOnly
                        disabled
                      />
                    ) : (
                      <Select
                        {...formik.getFieldProps('fK_Customer')}
                        name='fK_Customer'
                        placeholder={
                          userType === 'INTERPRETER' ? 'Select company' : 'Select a customer'
                        }
                        value={customerOptions.find(
                          (option) => String(option.value) === String(formik.values.fK_Customer)
                        )}
                        onChange={(option: {value: any; label?: string}) => {
                          formik.setFieldValue('fK_Customer', option?.value || '')
                          updateData(option || '')
                          if (userType === 'CONSUMER' || userType === 'SYSTEM') {
                            refetchPreCallQuestion(option?.value || '')
                            formik.setFieldValue('serviceTypes', [])
                            formik.setFieldValue('secondaryOpiServiceTypes', [])
                            formik.setFieldValue('fK_ServiceType', '')
                            refetchService()
                          }
                          formik.setFieldValue('fK_Location', '')
                        }}
                        isDisabled={formik.isSubmitting || isUserLoading}
                        options={customerOptions}
                        onBlur={() => formik.setFieldTouched('fK_Customer', true)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            width: '100%',
                            border: '1px solid #e4e6ef',
                          }),
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: '#a4afc4',
                          }),
                        }}
                      />
                    )}
                    {formik.errors.fK_Customer && formik.touched.fK_Customer && (
                      <div className='d-block fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.fK_Customer}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='col-sm-12 col-md-6 col-lg-6'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Office Location
                    </label>
                    <div className='d-flex align-items-center'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <Select
                          {...formik.getFieldProps('fK_Location')}
                          name='fK_Location'
                          className='mt-1'
                          placeholder='Select a location'
                          value={
                            locationOptions?.find(
                              (option) =>
                                String(option.value) === String(formik.values.fK_Location)
                            ) ?? ''
                          }
                          onChange={(option: any) =>
                            formik.setFieldValue('fK_Location', option?.value || '')
                          }
                          isDisabled={formik.isSubmitting || isUserLoading}
                          options={locationOptions}
                          onBlur={() => formik.setFieldTouched('fK_Location', true)}
                          styles={{
                            control: (provided: any) => ({
                              ...provided,
                              width: '100%',
                              border: '1px solid #e4e6ef',
                            }),
                            placeholder: (provided: any) => ({
                              ...provided,
                              color: '#a4afc4',
                            }),
                          }}
                        />
                        {formik.errors.fK_Location && formik.touched.fK_Location && (
                          <div className='fv-plugins-message-container '>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.fK_Location}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <hr />
              {formik.values.userType === 'CONSUMER' && (
                <>
                <div className='row mb-3 g-4'>
                  <div className='col-lg-6 col-sm-12'>
                    <label htmlFor='exampleFormControlInput1' className='required form-label fs-7 mb-1 '>
                      Service Type(s)
                    </label>
                    <div>
                      <div className=''>
                        <Select
                          name='serviceTypes'
                          isMulti
                          isDisabled={
                            formik.isSubmitting || isUserLoading || formik.values.fK_Customer === ''
                              ? true
                              : false
                          }
                          placeholder='Select Service Types'
                          value={formik.values.serviceTypes}
                          onChange={(selectedOptions: any[]) => {
                            const nextServiceTypes = selectedOptions ? selectedOptions : []
                            if (
                              nextServiceTypes.length === 0 ||
                              !nextServiceTypes.find(
                                (x: any) =>
                                  String(x.value) === String(formik.values.fK_ServiceType)
                              )
                            ) {
                              formik.setFieldValue('fK_ServiceType', '')
                            }
                            formik.setFieldValue('serviceTypes', nextServiceTypes)
                            const allowedValues = new Set(nextServiceTypes.map((x: any) => x.value))
                            const currentSecondary = formik.values.secondaryOpiServiceTypes || []
                            formik.setFieldValue(
                              'secondaryOpiServiceTypes',
                              currentSecondary.filter(
                                (s: any) =>
                                  allowedValues.has(s.value) &&
                                  s.value !== formik.values.fK_ServiceType
                              )
                            )
                          }}
                          options={!isFetchingServiceType ? serviceOptions : []}
                          styles={{
                            control: (provided: any) => ({
                              ...provided,
                              width: '100%',
                              border: '1px solid #e4e6ef',
                            }),
                            placeholder: (provided: any) => ({
                              ...provided,
                              color: '#a4afc4',
                            }),
                          }}
                          onBlur={() => formik.setFieldTouched('serviceTypes', true)}
                        />
                        {formik.errors.serviceTypes && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{String(formik.errors.serviceTypes)}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6 col-sm-12'>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Primary OPI Service Type
                    </label>
                    <div className='d-flex align-items-center'>
                      <div className='col-sm-12 col-md-12 col-lg-12'>
                        <Select
                          id='fK_ServiceType'
                          name='fK_ServiceType'
                          placeholder='Select a service'
                          options={formik.values.serviceTypes || []}
                          value={
                            (formik.values.serviceTypes || []).find(
                              (option: any) =>
                                String(option.value) === String(formik.values.fK_ServiceType)
                            ) ?? null
                          }
                          onChange={(option: any) => {
                            const nextPrimary = option?.value ?? ''
                            formik.setFieldValue('fK_ServiceType', nextPrimary)
                            const currentSecondary = formik.values.secondaryOpiServiceTypes || []
                            formik.setFieldValue(
                              'secondaryOpiServiceTypes',
                              currentSecondary.filter((s: any) => s.value !== nextPrimary)
                            )
                          }}
                          isDisabled={
                            formik.isSubmitting || isUserLoading || formik.values.fK_Customer === ''
                              ? true
                              : false
                          }
                          onBlur={() => formik.setFieldTouched('fK_ServiceType', true)}
                          styles={{
                            control: (provided: any) => ({
                              ...provided,
                              width: '100%',
                              border: '1px solid #e4e6ef',
                            }),
                            placeholder: (provided: any) => ({
                              ...provided,
                              color: '#a4afc4',
                            }),
                          }}
                        />
                        {formik.errors.fK_ServiceType && formik.touched.fK_ServiceType && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.fK_ServiceType}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-3 g-4'>
                  <div className='col-md-6 col-sm-12'>
                  </div>
                  <div className='col-md-6 col-sm-12'>
                    <label className='form-label fs-7 mb-1 d-inline-flex align-items-center gap-1'>
                      Secondary OPI Service Type(s)
                      <OverlayTrigger
                        placement='top'
                        overlay={
                          <Tooltip id='secondary-opi-service-types-tooltip'>
                            <div className='text-start fs-8'>
                              <div>
                                • Optional — leave empty to keep current OPI routing unchanged.
                              </div>
                              <div>
                                • Add one or more service types as fallbacks when the Default
                                Service Type has no interpreters/accepters.
                              </div>
                              <div>
                                • Tag numbers (1, 2, …) are the sort order: selection order is
                                saved and used as escalation sequence.
                              </div>
                              <div>• The Default Service Type cannot be selected here.</div>
                            </div>
                          </Tooltip>
                        }
                      >
                        <i
                          className='bi bi-info-circle text-muted'
                          style={{cursor: 'pointer', fontSize: '0.9rem'}}
                          aria-label='Secondary OPI service types info'
                        />
                      </OverlayTrigger>
                    </label>
                    <div>
                      <Select
                        name='secondaryOpiServiceTypes'
                        isMulti
                        placeholder='Select secondary service types (optional)'
                        options={(formik.values.serviceTypes || []).filter(
                          (o: any) => o.value !== formik.values.fK_ServiceType
                        )}
                        value={formik.values.secondaryOpiServiceTypes || []}
                        formatOptionLabel={(option: any, {context}: {context: string}) => {
                          if (context !== 'value') return option.label
                          const selected = formik.values.secondaryOpiServiceTypes || []
                          const sortOrder = selected.findIndex((s: any) => s.value === option.value)
                          if (sortOrder < 0) return option.label
                          return `${sortOrder + 1}. ${option.label}`
                        }}
                        onChange={(selectedOptions: any) =>
                          formik.setFieldValue(
                            'secondaryOpiServiceTypes',
                            selectedOptions ? selectedOptions : []
                          )
                        }
                        isDisabled={
                          formik.isSubmitting || isUserLoading || formik.values.fK_Customer === ''
                        }
                        onBlur={() => formik.setFieldTouched('secondaryOpiServiceTypes', true)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            width: '100%',
                            border: '1px solid #e4e6ef',
                          }),
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: '#a4afc4',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
                </>
              )}
              <hr />
              <div className='row mb-3'>
                <div className='col-lg-6 col-sm-12'>
                  <label
                    htmlFor='exampleFormControlInput1'
                    className='required form-label fs-7 mb-1 '
                  >
                    Native Language
                  </label>
                  <div className=''>
                    <Select
                      {...formik.getFieldProps('fK_DefaultNativeLanguage')}
                      name='fK_DefaultNativeLanguage'
                      placeholder='Select a language'
                      options={languageOptions}
                      value={languageOptions?.find(
                        (option) => option.value === formik.values.fK_DefaultNativeLanguage
                      )}
                      onChange={(option: {value: any}) =>
                        formik.setFieldValue('fK_DefaultNativeLanguage', option?.value || '')
                      }
                      isDisabled={formik.isSubmitting || isUserLoading}
                      onBlur={() => formik.setFieldTouched('fK_DefaultNativeLanguage', true)}
                      styles={{
                        control: (provided: any) => ({
                          ...provided,
                          width: '100%',
                          border: '1px solid #e4e6ef',
                        }),
                        placeholder: (provided: any) => ({
                          ...provided,
                          color: '#a4afc4',
                        }),
                      }}
                    />
                    {formik.errors.fK_DefaultNativeLanguage &&
                      formik.touched.fK_DefaultNativeLanguage && (
                        <div className='fv-plugins-message-container '>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.fK_DefaultNativeLanguage}</span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>

                <div className='col-lg-6 col-sm-12'>
                  <label
                    htmlFor='exampleFormControlInput1'
                    className='required form-label fs-7 mb-1 '
                  >
                    Default Timezone
                  </label>
                  <div>
                    <div className='w-100'>
                      <Select
                        {...formik.getFieldProps('fK_DefaultTimeZone')}
                        name='fK_DefaultTimeZone'
                        placeholder='Select a timezone'
                        options={TimezoneOptions}
                        value={TimezoneOptions?.find(
                          (option) => option.value === formik.values.fK_DefaultTimeZone
                        )}
                        onChange={(option: {value: any}) =>
                          formik.setFieldValue('fK_DefaultTimeZone', option?.value || '')
                        }
                        isDisabled={formik.isSubmitting || itemIdForUpdate || isUserLoading}
                        onBlur={() => formik.setFieldTouched('fK_DefaultTimeZone', true)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            width: '100%',
                            border: '1px solid #e4e6ef',
                          }),
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: '#a4afc4',
                          }),
                        }}
                      />
                      {formik.errors.fK_DefaultTimeZone && formik.touched.fK_DefaultTimeZone && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.fK_DefaultTimeZone}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-3'>
                <div
                  className='col-sm-12 col-md-6 col-lg-6'
                  hidden={!(userType === 'CONSUMER' && true)}
                >
                  <label className='form-label fs-7 mb-1 '>Pre Call Policy</label>
                  <div className='d-flex align-items-center'>
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                      <Select
                        {...formik.getFieldProps('fK_PreCallPolicy')}
                        name='fK_PreCallPolicy'
                        placeholder='Select a policy'
                        value={preCallPolicyOptions.find(
                          (option) => option.value === formik.values.fK_PreCallPolicy
                        )}
                        onChange={(option: {value: any}) =>
                          formik.setFieldValue('fK_PreCallPolicy', option?.value || '')
                        }
                        isDisabled={
                          formik.isSubmitting ||
                          isUserLoading ||
                          isPreCallQuestionLoading ||
                          formik.values.fK_Customer === ''
                        }
                        options={preCallPolicyOptions}
                        onBlur={() => formik.setFieldTouched('fK_PreCallPolicy', true)}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            width: '100%',
                            border: '1px solid #e4e6ef',
                          }),
                          placeholder: (provided: any) => ({
                            ...provided,
                            color: '#a4afc4',
                          }),
                        }}
                      />
                      {formik.errors.fK_PreCallPolicy && (
                        <div className='d-block fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.fK_PreCallPolicy}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <br />

              <>
                <div
                  className='card mb-5 mb-xl-5 bg-light'
                  // style={{backgroundColor: '#FAF7F5'}}
                  hidden={(userType === 'INTERPRETER' || userType === 'SYSTEM') && true}
                >
                  <div className='card-body p-5'>
                    <div className='d-flex flex-wrap flex-sm-nowrap mb-3 w-100'>
                      <div className='w-100'>
                        <div className='d-flex mb-2 flex-column w-100'>
                          <h5 className='text-black fs-3 fw-bold'>
                            {' '}
                            Pre-Authenticated PIN Management
                          </h5>
                          <h5 className='text-gray-600 text-hover-primary fw-normal me-1'>
                            (HINT : 'Should have minimum 4 digits and maximum 10 digits')
                          </h5>
                          <div className='mb-1'>
                            <div className='d-flex justify-content-between align-items-center w-100'>
                              <div className='d-flex flex-grow-1'>
                                <input
                                  placeholder='PIN CODE'
                                  {...formik.getFieldProps('pinCode')}
                                  type='text'
                                  name='pinCode'
                                  style={{
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    letterSpacing: '0.5em',
                                    height: '45px',
                                    textAlign: 'center',
                                  }}
                                  className={clsx(
                                    'form-control form-control-white  mb-2 p-3 border border-dashed min-w-100px mt-2 bg-white border-gray-300 me-3'
                                  )}
                                  autoComplete='off'
                                  onChange={handlePinCodeChange}
                                  disabled={formik.isSubmitting || isUserLoading}
                                />
                              </div>
                              <div className='d-flex ms-3'>
                                <button
                                  type='button'
                                  onClick={() => GeneratePinCode()}
                                  className='btn btn-primary '
                                  disabled={isUserLoading || isPinCodeGenerated}
                                >
                                  {(isPinCodeGenerated || isUserLoading) && (
                                    <span className=''>
                                      Please wait...{' '}
                                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                  )}
                                  {!isPinCodeGenerated && (
                                    <span className='indicator-label'>
                                      <i className='bi bi-arrow-repeat fs-6'></i>
                                      Generate
                                    </span>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className='mt-2 mb-3'>
                            <div className='row g-4 g-xl-6'>
                              {formik.errors.pinCode && formik.touched.pinCode && (
                                <div className='fv-plugins-message-container'>
                                  <div className='fv-help-block'>
                                    <span role='alert'>{formik.errors.pinCode}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          {!isCheckAvailabilty && availabilityStatus && (
                            <>
                              <div className='mb-3'>
                                <div className='row g-4 g-xl-6'>
                                  <div className='d-flex align-items-center'>
                                    {!availabilityStatus?.data && (
                                      <>
                                        <div className='w-100 p-2 border border-success bg-white text-success rounded text-center fw-bold'>
                                          {' '}
                                          AVAILABLE
                                        </div>
                                      </>
                                    )}

                                    {availabilityStatus?.data && (
                                      <>
                                        {' '}
                                        <div className='w-100 p-2 border border-danger bg-white text-danger rounded text-center fw-bold'>
                                          {' '}
                                          NOT AVAILABLE
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          <div className='mb-2 mt-2 w-100'>
                            <div className='d-flex flex-start'>
                              <div className='d-flex align-items-center flex-end'>
                                {/*<button
                                  style={{width: '100R%'}}
                                  type='reset'
                                 // onClick={() => fn_CheckAvailabilty()}
                                  className='btn btn-success btn-sm'
                                  data-kt-users-modal-action='cancel'
                                  disabled={
                                    isCheckAvailabilty ||
                                    isUserLoading ||
                                    isPinCodeGenerated ||
                                    isPinCodeError ||
                                    isGenPinCode
                                  }
                                >
                                  {(isCheckAvailabilty || isUserLoading) && (
                                    <span className=''>
                                      Please wait...{' '}
                                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                  )}
                                  {!isCheckAvailabilty && (
                                    <span className='indicator-label'>CHECK AVAILABILTY</span>
                                  )}
                                </button>*/}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>

              {/* <div className='mb-3'>
                <div className='row g-4 g-xl-6'>
                  <div className=''>
                    <label
                      htmlFor='exampleFormControlInput1'
                      className='required form-label fs-7 mb-1 '
                    >
                      Native Language & Default Service Type
                    </label>
                    <div className='d-flex align-items-center'>
                      <select
                        {...formik.getFieldProps('fK_DefaultNativeLanguage')}
                        name='fK_DefaultNativeLanguage'
                        className={clsx('form-select form-select-sm form-select-white')}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isUserLoading}
                      >
                        <option value=''>Select a Language</option>

                      </select>
                      <select
                        {...formik.getFieldProps('fK_ServiceType')}
                        name='fK_ServiceType'
                        className={clsx(
                          'form-select form-select-sm form-select-white ms-3'
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isUserLoading}
                      >
                        <option value=''>Select a Service</option>

                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mb-3'>
                <label htmlFor='exampleFormControlInput1' className='required form-label fs-7 mb-1 '>
                  Default Timezone
                </label>
                <div>
                  <div className='w-100'>
                    <select
                      {...formik.getFieldProps('fK_DefaultTimeZone')}
                      name='fK_DefaultTimeZone'
                      className={clsx(
                        'form-select form-select-sm form-select-white mb-2'
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isUserLoading}
                    >
                      <option value=''>Select a Time Zone</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className='mb-3'>
                <div className='row g-4 g-xl-6'>
                  {/* <div className='col-sm-6 col-md-6 col-lg-6 mb-5 '>
                    <div className=''>
                      <label htmlFor='exampleFormControlInput1' className='required form-label fs-7 mb-1 '>
                        Password Policy
                      </label>
                      <div className='d-flex align-items-center'>
                        <select
                          {...formik.getFieldProps('isNewPasswordGenerate')}
                          name='isNewPasswordGenerate'
                          className={clsx('form-select form-select-sm form-select-white')}
                          autoComplete='off'
                          disabled={formik.isSubmitting || isUserLoading}
                          onChange={(e) => {
                            formik.setFieldValue('isNewPasswordGenerate', e.target.value)
                            updateData(e.target.value)
                          }}
                        >
                          <option value='false'>No</option>
                          <option value='true'>Auto Regenerate Password sent via Email</option>
                        </select>
                        {formik.values.isNewPasswordGenerate + '' == 'true' ||
                          formik.values.isNewPasswordGenerate == true}
                        {formik.errors.isNewPasswordGenerate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.isNewPasswordGenerate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}
                  {itemIdForUpdate && (
                    <div className='col-sm-6 col-md-6 col-lg-6 d-flex align-items-center'>
                      <div className='form-check-custom form-check-white form-check-sm mt-3 mb-3'>
                        <input
                          id='lockoutEnabledCheck'
                          placeholder=''
                          {...formik.getFieldProps('lockoutEnabled')}
                          type='checkbox'
                          name='lockoutEnabled'
                          className={clsx(
                            'form-check-input',
                            {
                              'is-invalid':
                                formik.touched.lockoutEnabled && formik.errors.lockoutEnabled,
                            },
                            {
                              'is-valid':
                                formik.touched.lockoutEnabled && !formik.errors.lockoutEnabled,
                            }
                          )}
                          checked={formik.values.lockoutEnabled}
                          disabled={formik.isSubmitting || isUserLoading}
                        />
                        {formik.touched.lockoutEnabled && formik.errors.lockoutEnabled && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.lockoutEnabled}</span>
                            </div>
                          </div>
                        )}

                        <label
                          className='form-check-label form-check-sm'
                          htmlFor='flexCheckDefault2'
                        >
                          Deactivate
                        </label>
                      </div>
                    </div>
                  )}
                  {itemIdForUpdate && isDeactivating && (
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                      <DeactivationReasonSelect
                        value={formik.values.deactivationReason}
                        onChange={(value) => formik.setFieldValue('deactivationReason', value)}
                        disabled={formik.isSubmitting || isUserLoading}
                      />
                    </div>
                  )}

                  {formik.values.userType === 'CONSUMER' && (
                    <div className='col-sm-6 col-md-6 col-lg-6 d-flex flex-column'>
                    <div className='form-check-custom form-check-white form-check-sm mt-3 mb-3'>
                      <input
                        id='recieveAllEmails'
                        placeholder=''
                        type='checkbox'
                        name='recieveAllEmails'
                        className={clsx(
                          'form-check-input',
                          {
                            'is-invalid':
                              formik.touched.recieveAllEmails && formik.errors.recieveAllEmails,
                          },
                          {
                            'is-valid':
                              formik.touched.recieveAllEmails && !formik.errors.recieveAllEmails,
                          }
                        )}
                        checked={formik.values.recieveAllEmails}
                        disabled={formik.isSubmitting || isUserLoading}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const checked = e.target.checked
                          if (checked) {
                            // If selecting "Recieve All Emails", uncheck "Recieve User Emails"
                            formik.setFieldValue('recieveAllEmails', true)
                            formik.setFieldValue('recieveUserEmails', false)
                          } else {
                            // Allow both to be unchecked
                            formik.setFieldValue('recieveAllEmails', false)
                          }
                        }}
                        onBlur={() => formik.setFieldTouched('recieveAllEmails', true)}
                      />
                      {formik.touched.recieveAllEmails && formik.errors.recieveAllEmails && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.recieveAllEmails}</span>
                          </div>
                        </div>
                      )}

                      <label
                        className='form-check-label form-check-sm'
                        htmlFor='flexCheckDefault2'
                      >
                        Recieve All Emails
                      </label>
                    </div>

                    <div className='form-check-custom form-check-white form-check-sm mt-3 mb-3'>
                      <input
                        id='recieveUserEmails'
                        placeholder=''
                        type='checkbox'
                        name='recieveUserEmails'
                        className={clsx(
                          'form-check-input',
                          {
                            'is-invalid':
                              formik.touched.recieveUserEmails && formik.errors.recieveUserEmails,
                          },
                          {
                            'is-valid':
                              formik.touched.recieveUserEmails && !formik.errors.recieveUserEmails,
                          }
                        )}
                        checked={formik.values.recieveUserEmails}
                        disabled={formik.isSubmitting || isUserLoading}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const checked = e.target.checked
                          if (checked) {
                            // If selecting "Recieve User Emails", uncheck "Recieve All Emails"
                            formik.setFieldValue('recieveUserEmails', true)
                            formik.setFieldValue('recieveAllEmails', false)
                          } else {
                            // Allow both to be unchecked
                            formik.setFieldValue('recieveUserEmails', false)
                          }
                        }}
                        onBlur={() => formik.setFieldTouched('recieveUserEmails', true)}
                      />
                      {formik.touched.recieveUserEmails && formik.errors.recieveUserEmails && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.recieveUserEmails}</span>
                          </div>
                        </div>
                      )}

                      <label
                        className='form-check-label form-check-sm'
                        htmlFor='flexCheckDefault2'
                      >
                        Recieve User Emails
                      </label>
                    </div>
                  </div>
                )}

                </div>
              </div>
              <div>
                {!itemIdForUpdate && (
                  <div hidden={userType === 'SYSTEM' && true}>
                    <h5>Permissions</h5>
                    <hr />
                    <div className='mb-3'>
                      <div className='row g-4 g-xl-6'>
                        <div className='col-sm-6 col-md-6 col-lg-6 '>
                          <label className='form-label fs-7 mb-1 '>OPI</label>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='form-check-custom form-check-white form-check-sm-12'>
                              <input
                                placeholder=''
                                {...formik.getFieldProps('opI_ShdTelephonic')}
                                type='checkbox'
                                name='opI_ShdTelephonic'
                                className={clsx(
                                  'form-check-input',
                                  {
                                    'is-invalid':
                                      formik.touched.opI_ShdTelephonic &&
                                      formik.errors.opI_ShdTelephonic,
                                  },
                                  {
                                    'is-valid':
                                      formik.touched.opI_ShdTelephonic &&
                                      !formik.errors.opI_ShdTelephonic,
                                  }
                                )}
                                checked={formik.values.opI_ShdTelephonic}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label
                                className='form-check-label form-check-sm'
                                htmlFor='flexCheckDefault'
                              >
                                Scheduled Telephonic
                              </label>
                            </div>
                          </div>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='form-check-custom form-check-white form-check-sm-12'>
                              <input
                                placeholder=''
                                {...formik.getFieldProps('opI_OndemandTelephonic')}
                                type='checkbox'
                                name='opI_OndemandTelephonic'
                                className={clsx(
                                  'form-check-input',
                                  {
                                    'is-invalid':
                                      formik.touched.opI_OndemandTelephonic &&
                                      formik.errors.opI_OndemandTelephonic,
                                  },
                                  {
                                    'is-valid':
                                      formik.touched.opI_OndemandTelephonic &&
                                      !formik.errors.opI_OndemandTelephonic,
                                  }
                                )}
                                checked={formik.values.opI_OndemandTelephonic}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label
                                className='form-check-label form-check-sm'
                                htmlFor='flexCheckDefault'
                              >
                                On-Demand Telephonic
                              </label>
                            </div>
                          </div>
                          <br />

                          <div>
                            <label className='form-label fs-7 mb-1 '>VRI</label>
                            <div className='d-flex align-items-center mb-2'>
                              <div className='form-check-custom form-check-white form-check-sm-12'>
                                <input
                                  placeholder=''
                                  {...formik.getFieldProps('vrI_ShdVideoInteroreting')}
                                  type='checkbox'
                                  name='vrI_ShdVideoInteroreting'
                                  className={clsx(
                                    'form-check-input',
                                    {
                                      'is-invalid':
                                        formik.touched.vrI_ShdVideoInteroreting &&
                                        formik.errors.vrI_ShdVideoInteroreting,
                                    },
                                    {
                                      'is-valid':
                                        formik.touched.vrI_ShdVideoInteroreting &&
                                        !formik.errors.vrI_ShdVideoInteroreting,
                                    }
                                  )}
                                  checked={formik.values.vrI_ShdVideoInteroreting}
                                  disabled={formik.isSubmitting || isUserLoading}
                                />
                                <label
                                  className='form-check-label form-check-sm'
                                  htmlFor='flexCheckDefault'
                                >
                                  Scheduled Video Interpreting
                                </label>
                              </div>
                            </div>
                            <div className='d-flex align-items-center'>
                              <div className='form-check-custom form-check-white form-check-sm-12'>
                                <input
                                  placeholder=''
                                  {...formik.getFieldProps('vrI_OndemandVideoInteroreting')}
                                  type='checkbox'
                                  name='vrI_OndemandVideoInteroreting'
                                  className={clsx(
                                    'form-check-input',
                                    {
                                      'is-invalid':
                                        formik.touched.vrI_OndemandVideoInteroreting &&
                                        formik.errors.vrI_OndemandVideoInteroreting,
                                    },
                                    {
                                      'is-valid':
                                        formik.touched.vrI_OndemandVideoInteroreting &&
                                        !formik.errors.vrI_OndemandVideoInteroreting,
                                    }
                                  )}
                                  checked={formik.values.vrI_OndemandVideoInteroreting}
                                  disabled={formik.isSubmitting || isUserLoading}
                                />
                                <label
                                  className='form-check-label form-check-sm'
                                  htmlFor='flexCheckDefault'
                                >
                                  On-Demand Video Interpreting
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-sm-6 col-md-6 col-lg-6 '>
                          <label className='form-label fs-7 mb-1 '>OSI</label>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='form-check-custom form-check-white form-check-sm-12'>
                              <input
                                placeholder=''
                                {...formik.getFieldProps('osI_OnsiteConsecutive')}
                                type='checkbox'
                                name='osI_OnsiteConsecutive'
                                className={clsx(
                                  'form-check-input',
                                  {
                                    'is-invalid':
                                      formik.touched.osI_OnsiteConsecutive &&
                                      formik.errors.osI_OnsiteConsecutive,
                                  },
                                  {
                                    'is-valid':
                                      formik.touched.osI_OnsiteConsecutive &&
                                      !formik.errors.osI_OnsiteConsecutive,
                                  }
                                )}
                                checked={formik.values.osI_OnsiteConsecutive}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label
                                className='form-check-label form-check-sm'
                                htmlFor='flexCheckDefault'
                              >
                                Onsite Consecutive
                              </label>
                            </div>
                          </div>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='form-check-custom form-check-white form-check-sm-12'>
                              <input
                                placeholder=''
                                {...formik.getFieldProps('osI_OnsiteSimultaneous')}
                                type='checkbox'
                                name='osI_OnsiteSimultaneous'
                                className={clsx(
                                  'form-check-input',
                                  {
                                    'is-invalid':
                                      formik.touched.osI_OnsiteSimultaneous &&
                                      formik.errors.osI_OnsiteSimultaneous,
                                  },
                                  {
                                    'is-valid':
                                      formik.touched.osI_OnsiteSimultaneous &&
                                      !formik.errors.osI_OnsiteSimultaneous,
                                  }
                                )}
                                checked={formik.values.osI_OnsiteSimultaneous}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label
                                className='form-check-label form-check-sm'
                                htmlFor='flexCheckDefault'
                              >
                                Onsite Simultaneous
                              </label>
                            </div>
                          </div>
                          {/* <div className='d-flex align-items-center mb-2'>
                      <div className='form-check-custom form-check-white form-check-sm-12'>
                        <input
                          placeholder=''
                          {...formik.getFieldProps('osI_OnsiteWhisper')}
                          type='checkbox'
                          name='osI_OnsiteWhisper'
                          className={clsx(
                            'form-check-input',
                            {
                              'is-invalid':
                                formik.touched.osI_OnsiteWhisper && formik.errors.osI_OnsiteWhisper,
                            },
                            {
                              'is-valid':
                                formik.touched.osI_OnsiteWhisper &&
                                !formik.errors.osI_OnsiteWhisper,
                            }
                          )}
                          checked={formik.values.osI_OnsiteWhisper}
                          disabled={formik.isSubmitting || isUserLoading}
                        />
                        <label
                          className='form-check-label form-check-sm'
                          htmlFor='flexCheckDefault'
                        >
                          Onsite Whisper
                        </label>
                      </div>
                    </div>
                    <div className='d-flex align-items-center mb-2'>
                      <div className='form-check-custom form-check-white form-check-sm-12'>
                        <input
                          placeholder=''
                          {...formik.getFieldProps('osI_Onsite')}
                          type='checkbox'
                          name='osI_Onsite'
                          className={clsx(
                            'form-check-input',
                            {'is-invalid': formik.touched.osI_Onsite && formik.errors.osI_Onsite},
                            {
                              'is-valid': formik.touched.osI_Onsite && !formik.errors.osI_Onsite,
                            }
                          )}
                          checked={formik.values.osI_Onsite}
                          disabled={formik.isSubmitting || isUserLoading}
                        />
                        <label
                          className='form-check-label form-check-sm'
                          htmlFor='flexCheckDefault'
                        >
                          Onsite
                        </label>
                      </div>
                    </div> */}
                          <br />
                          <label className='form-label fs-7 mb-1 '>Other</label>
                          <div className='d-flex align-items-center mb-2'>
                            <div className='form-check-custom form-check-white form-check-sm-12'>
                              <input
                                placeholder=''
                                {...formik.getFieldProps('other_3rdPartyPlatform')}
                                type='checkbox'
                                name='other_3rdPartyPlatform'
                                className={clsx(
                                  'form-check-input',
                                  {
                                    'is-invalid':
                                      formik.touched.other_3rdPartyPlatform &&
                                      formik.errors.other_3rdPartyPlatform,
                                  },
                                  {
                                    'is-valid':
                                      formik.touched.other_3rdPartyPlatform &&
                                      !formik.errors.other_3rdPartyPlatform,
                                  }
                                )}
                                checked={formik.values.other_3rdPartyPlatform}
                                disabled={formik.isSubmitting || isUserLoading}
                              />
                              <label
                                className='form-check-label form-check-sm'
                                htmlFor='flexCheckDefault'
                              >
                                Third Party Platform
                              </label>
                            </div>
                          </div>
                          {userType === 'CONSUMER' && (
                            <div className='d-flex align-items-center mb-2'>
                              <div className='form-check-custom form-check-white form-check-sm-12'>
                                <input
                                  placeholder=''
                                  {...formik.getFieldProps('translations')}
                                  type='checkbox'
                                  name='translations'
                                  className={clsx(
                                    'form-check-input',
                                    {
                                      'is-invalid':
                                        formik.touched.translations && formik.errors.translations,
                                    },
                                    {
                                      'is-valid':
                                        formik.touched.translations && !formik.errors.translations,
                                    }
                                  )}
                                  checked={formik.values.translations}
                                  disabled={formik.isSubmitting || isUserLoading}
                                />
                                <label
                                  className='form-check-label form-check-sm'
                                  htmlFor='flexCheckDefault'
                                >
                                  Translations
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <br />
                <h5>Roles</h5>
                <hr />
                <div className='mb-7'>
                  {response?.data?.map((value, i) => (
                    <>
                      <div className='d-flex fv-row'>
                        <div className='form-check form-check-custom form-check-solid'>
                          <input
                            className='form-check-input role-radio-input'
                            {...formik.getFieldProps('role')}
                            name='role'
                            type='radio'
                            value={value.name}
                            id='kt_modal_update_role_option_0'
                            defaultChecked={i === 0 ? true : false}
                            disabled={formik.isSubmitting || isUserLoading || isEditingSelf}
                            checked={value.name === formik.values.role ? true : false}
                            onChange={() => {
                              formik.setFieldValue('role', value.name)
                            }}
                          />
                          <label
                            className='form-check-label form-check-sm role-radio-label'
                            htmlFor='kt_modal_update_role_option_0'
                          >
                            {value.name}
                            <div className='text-gray-600'>{value.status}</div>
                          </label>
                        </div>
                      </div>
                      {value?.name?.includes('Requester Content Admin') &&
                        value.name === formik.values.role && (
                          <div className='form-check form-check-custom form-check-solid ml-4 mt-4'>
                            <input
                              type='checkbox'
                              id={`kt_modal_update_role_option_1`}
                              name='accessBilling'
                              className='form-check-input'
                              checked={formik.values.accessBilling || false}
                              onChange={(e) =>
                                formik.setFieldValue('accessBilling', e.target.checked)
                              }
                            />
                            <label
                              htmlFor={`kt_modal_update_role_option_1`}
                              className='form-check-label ms-2'
                            >
                              Access Billing
                            </label>
                          </div>
                        )}
                      <div className='separator separator-dashed my-5'></div>
                    </>
                  ))}
                  {formik.errors.role && formik.touched.role && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.role}</span>
                      </div>
                    </div>
                  )}
                  {response?.data?.length == 0 && <>No roles available to assign</>}
                </div>
                {userType === 'INTERPRETER' && (
                  <div className='mb-7'>
                    <div
                      className='form-check form-check-custom form-check-solid'
                      style={!isAdmin ? {opacity: 0.6} : undefined}
                    >
                      <input
                        type='checkbox'
                        id='isAllowedMobileLogin'
                        name='isAllowedMobileLogin'
                        className='form-check-input'
                        checked={formik.values.isAllowedMobileLogin || false}
                        disabled={!isAdmin || formik.isSubmitting || isUserLoading}
                        onChange={(e) =>
                          formik.setFieldValue('isAllowedMobileLogin', e.target.checked)
                        }
                      />
                      <label
                        className='form-check-label ms-2'
                        htmlFor='isAllowedMobileLogin'
                        style={!isAdmin ? {cursor: 'not-allowed'} : undefined}
                      >
                        <Smartphone /> Mobile application access
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='modal-footer py-3 px-0'>
            <button
              type='reset'
              onClick={() => cancel()}
              className='btn btn-light me-3 btn-sm'
              data-kt-users-modal-action='cancel'
              disabled={formik.isSubmitting || isUserLoading}
            >
              Discard
            </button>
            <button
              className='btn btn-primary btn-sm'
              data-kt-users-modal-action='submit'
              disabled={
                isUserLoading || formik.isSubmitting || !!availabilityStatus?.data || !formik.dirty ||
                (isDeactivating && !formik.values.deactivationReason)
              }
              onClick={() => {
                formik.submitForm()
              }}
            >
              <span className='indicator-label'>Save</span>
              {(formik.isSubmitting || isUserLoading) && (
                <span className='indicator-progress'>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </>
  )
}

export {UserEditModalForm}

// Insert the styles into the document head
const styleSheet = document.createElement('style')
styleSheet.innerText = styles
document.head.appendChild(styleSheet)